<template>
  <div>
    <v-main>
      <div class="pl-12 pr-12 col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-row>
          <v-col cols="12" class="text-left pb-0">
            <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
          </v-col>
        </v-row>

        <v-card flat class="mb-4 queue-filter-card">
          <v-card-text>
            <v-row align="center">
              <v-col cols="12" sm="6" md="auto" class="queue-filter-col">
                <v-select
                  class="queue-filter-control"
                  v-model="mode"
                  :items="availableModeItems"
                  label="โหมด"
                  outlined
                  dense
                  hide-details
                  @change="changeMode()"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="auto" class="queue-filter-col">
                <v-autocomplete
                  class="queue-filter-control"
                  v-model="masBranchID"
                  :items="branchItem"
                  label="สาขา"
                  outlined
                  dense
                  hide-details
                  @change="changeBranch()"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="auto" class="queue-filter-col">
                <v-menu
                  ref="menuStart"
                  v-model="menuStart"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      class="queue-filter-control"
                      v-model="dateStart"
                      label="วันที่"
                      readonly
                      outlined
                      dense
                      hide-details
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dateStart"
                    no-title
                    scrollable
                    @input="menuStart = false, loadData()"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="auto" class="queue-filter-col" v-if="simultaneousCallEnabled">
                <v-select
                  class="queue-filter-control"
                  v-model="queueType"
                  :items="queueTypeItems"
                  label="ประเภทคิว"
                  outlined
                  dense
                  hide-details
                  @change="loadData()"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="auto" class="queue-filter-col">
                <v-text-field
                  class="queue-filter-control"
                  v-model="search"
                  label="ค้นหา"
                  append-icon="mdi-magnify"
                  outlined
                  dense
                  hide-details
                  @keyup.enter="loadData()"
                ></v-text-field>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12" md class="queue-action-col">
                <download-excel
                  class="queue-export-wrapper"
                  :data="exportData"
                  :fields="exportFields"
                  type="xls"
                  :worksheet="exportWorksheet"
                  :name="exportFileName"
                >
                  <v-btn class="queue-toolbar-btn queue-export-btn" color="teal" dark :disabled="exportData.length === 0">
                    <v-icon left>mdi-download</v-icon>
                    Export
                  </v-btn>
                </download-excel>
                <v-btn class="queue-toolbar-btn queue-refresh-btn" color="primary" outlined @click="loadData()">
                  <v-icon left>mdi-refresh</v-icon>
                  โหลดใหม่
                </v-btn>
                <!-- <v-btn class="queue-toolbar-btn queue-print-setting-btn" color="#1B437C" outlined @click="openPrintSettingDialog()">
                  <v-icon left>mdi-printer-settings</v-icon>
                  ตั้งค่าปริ้น
                </v-btn> -->
                <ModelBookingList
                  v-if="mode === 'department'"
                  class="forward-add-booking"
                  @reset-data="emitResetData"
                ></ModelBookingList>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-row class="mb-3 queue-overview-row" v-if="overviewDisplayItems.length > 0">
          <v-col cols="auto" v-for="item in overviewDisplayItems" :key="item.id">
            <v-card
              outlined
              :class="['pa-3', 'queue-overview-card', {'queue-overview-card-active': isSelectedOverview(item)}]"
              :color="isSelectedOverview(item) ? '#C9F2DC' : 'white'"
              @click="selectOverview(item)"
            >
              <strong>{{ overviewName(item) }}</strong>
              <div>จำนวน : {{ item.countQueue || 0 }}</div>
            </v-card>
          </v-col>
        </v-row>

        <v-card>
          <v-data-table
            class="queue-data-table"
            :headers="tableHeaders"
            :items="itemBooking"
            :loading="loading"
            item-key="bookNo"
            :search="search"
            :item-class="getBookingRowClass"
          >
            <template v-slot:item.storeFrontQueue="{ item }">
              <div class="queue-number-cell">
                <v-btn text small color="#1B437C" class="queue-number-btn" @click="openHistoryDialog(item)">
                  <u>{{ item.storeFrontQueue || '-' }}</u>
                </v-btn>
                <v-btn
                  v-if="hasLineMember(item)"
                  icon
                  small
                  class="queue-line-btn"
                  title="ข้อมูล LINE"
                  @click.stop="openLineDialog(item)"
                >
                  <img :src="lineIcon" alt="LINE" class="queue-line-icon">
                </v-btn>
              </div>
            </template>
            <template v-slot:item.activeFlowName="{ item }">
              <div>{{ getDisplayFlowName(item) }}</div>
              <v-chip
                v-if="isReturnedQueue(item) && getReturnedQueueName(item)"
                x-small
                outlined
                color="#F59E0B"
                class="mt-1 returned-queue-chip"
              >
                ส่งกลับจาก {{ getReturnedQueueName(item) }}
              </v-chip>
            </template>
            <!-- <template v-slot:item.forwardQueueNameTh="{ item }">
              {{ item.forwardQueueNameTh || '-' }}
            </template> -->
            <template v-slot:item.servicePoint="{ item }">
              <!-- คิวส่งกลับที่ยังไม่ได้เรียก: ช่องบริการโชว์ห้องเดิมเหมือนคิวที่กำลังตรวจ ทำให้หมอเข้าใจผิด
                   จึงทำห้องให้จาง + ป้าย "ส่งกลับ • ยังไม่ได้เรียก" ให้ชัดว่ายังรอเรียก ไม่ใช่กำลังใช้ห้อง -->
              <template v-if="simultaneousCallEnabled && isReturnedQueue(item) && !item.call_queue_date_time && !isTerminalQueueStatus(item)">
                <div class="grey--text text--darken-1">{{ item.servicePoint || '-' }}</div>
                <v-chip x-small outlined color="#F59E0B" class="mt-1 returned-queue-chip">
                  ส่งกลับ • ยังไม่ได้เรียก
                </v-chip>
              </template>
              <template v-else>
                <!-- คิวที่ถูกส่งไปจุดส่งต่อ (เช่น รอจัดยา) ยังไม่มีห้อง ช่องบริการเดิมจึงโชว์ '-' ทั้งคอลัมน์
                     โชว์ชื่อจุดส่งต่อขึ้นก่อน แล้วค่อยต่อด้วยห้องถ้ามี -->
                <div>{{ getServicePointText(item) }}</div>
                <small
                  v-if="getForwardQueuePointName(item) && item.servicePoint"
                  class="service-point-origin"
                >
                  {{ item.servicePoint }}
                </small>
                <small
                  v-if="!item.servicePoint && item.forwardQueueId && item.forwardFromServicePoint"
                  class="service-point-origin"
                >
                  ส่งกลับ {{ item.forwardFromServicePoint }}
                </small>
              </template>
            </template>
            <template v-slot:item.customer="{ item }">
              <div>{{ item.bookingDataCustomerName || '-' }}</div>
              <small>{{ item.bookingDataCustomerTel || '' }}</small>
            </template>
            <template
              v-for="field in customerFieldNames"
              v-slot:[`item.field_${field.fieldId}`]="{ item }"
            >
              <div :key="'customer-field-' + field.fieldId" class="queue-customer-field-cell">
                <span>{{ item['field_' + field.fieldId] || '-' }}</span>
                <v-btn
                  icon
                  x-small
                  color="#1B437C"
                  class="queue-customer-field-edit-btn"
                  :title="'แก้ไข' + field.fieldName"
                  @click.stop="openCustomerFieldEditDialog(item, field)"
                >
                  <v-icon x-small>mdi-pencil</v-icon>
                </v-btn>
              </div>
            </template>
            <template v-slot:item.queueTimeText="{ item }">
              {{ getQueueTimeText(item) }}
            </template>
            <template v-slot:item.actionPrint="{ item }">
              <div class="queue-print-actions">
                <v-btn
                  small
                  outlined
                  color="#809FB8"
                  class="queue-print-btn mr-1"
                  @click="setPrint(item, 'th')"
                >
                  <v-icon small left>mdi-printer</v-icon>
                  TH
                </v-btn>
                <v-btn
                  small
                  outlined
                  color="#809FB8"
                  class="queue-print-btn"
                  @click="setPrint(item, 'en')"
                >
                  <v-icon small left>mdi-printer</v-icon>
                  EN
                </v-btn>
              </div>
            </template>
            <template v-slot:item.actions="{ item }">
              <template v-if="isTerminalQueueStatus(item)">
                <v-chip
                  small
                  dark
                  :color="getTerminalQueueStatusColor(item)"
                  class="queue-status-chip"
                >
                  {{ getTerminalQueueStatusText(item) }}
                </v-chip>
              </template>
              <template v-else-if="mode !== 'forward_point'">
                <template v-if="isDepartmentCallQueueOnly(item)">
                  <v-btn small rounded color="success" dark class="mr-1 queue-action-btn" @click="submitDirectAction(item, 'call_queue')">
                    เรียกคิว
                  </v-btn>
                  <v-btn small rounded outlined color="error" class="mr-1 queue-action-btn" @click="submitDirectAction(item, 'cancel_queue')">
                    ยกเลิกคิว
                  </v-btn>
                </template>
                <template v-else>
                  <v-btn
                    v-if="isReturnedParkedQueue(item)"
                    small
                    rounded
                    color="success"
                    dark
                    class="mr-1 queue-action-btn"
                    @click="submitDirectAction(item, 'call_queue')"
                  >
                    เรียกคิว
                  </v-btn>
                  <v-btn v-if="!isPullingFromOtherRoom(item)" small rounded color="#1B437C" dark class="mr-1 queue-action-btn" @click="openActionDialog(item, 'forward_to_point')">
                    คิวส่งต่อ
                  </v-btn>
                  <v-btn
                    v-if="!isReturnedParkedQueue(item)"
                    small
                    rounded
                    outlined
                    color="warning"
                    class="mr-1 queue-action-btn"
                    @click="submitDirectAction(item, 'recall_queue')"
                  >
                    เรียกคิวซ้ำ
                  </v-btn>
                  <v-btn v-if="!isPullingFromOtherRoom(item)" small rounded color="success" dark class="mr-1 queue-action-btn" @click="submitDirectAction(item, 'finish')">
                    เสร็จสิ้น
                  </v-btn>
                  <v-btn v-if="!isPullingFromOtherRoom(item)" small rounded outlined color="error" class="mr-1 queue-action-btn" @click="submitDirectAction(item, 'cancel_queue')">
                    ยกเลิกคิว
                  </v-btn>
                </template>
              </template>
              <template v-else>
                <template v-if="!isForwardPointCalled(item)">
                  <v-btn small rounded color="success" dark class="mr-1 queue-action-btn" @click="submitDirectAction(item, 'call_queue')">
                    เรียกคิว
                  </v-btn>
                  <v-btn small rounded outlined color="error" class="mr-1 queue-action-btn" @click="submitDirectAction(item, 'cancel_queue')">
                    ยกเลิกคิว
                  </v-btn>
                </template>
                <template v-else>
                  <v-btn small rounded color="#1B437C" dark class="mr-1 queue-action-btn" @click="openActionDialog(item, 'forward_to_point')">คิวส่งต่อ</v-btn>
                  <v-btn small rounded outlined color="#1B437C" class="mr-1 queue-action-btn" @click="submitDirectAction(item, 'return_to_flow')">คิวส่งกลับ</v-btn>
                  <v-btn small rounded outlined color="warning" class="mr-1 queue-action-btn" @click="submitDirectAction(item, 'recall_queue')">เรียกคิวซ้ำ</v-btn>
                  <v-btn small rounded color="success" dark class="mr-1 queue-action-btn" @click="submitDirectAction(item, 'finish')">เสร็จสิ้น</v-btn>
                  <v-btn small rounded outlined color="error" class="queue-action-btn" @click="submitDirectAction(item, 'cancel_queue')">ยกเลิกคิว</v-btn>
                </template>
              </template>
            </template>
          </v-data-table>
        </v-card>

        <v-dialog v-model="dialogCustomerFieldEdit" persistent max-width="520px">
          <v-card>
            <v-card-title class="queue-dialog-title">
              แก้ไข{{ editingCustomerField.fieldName || 'ข้อมูลลูกค้า' }}
              <v-spacer></v-spacer>
              <v-btn icon :disabled="customerFieldEditLoading" @click="closeCustomerFieldEditDialog()">
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-form ref="customerFieldEditForm" v-model="customerFieldEditValid" lazy-validation>
                <v-text-field
                  v-if="isCustomerFieldTextInput(editingCustomerField)"
                  v-model="customerFieldEditValue"
                  :label="editingCustomerField.fieldName"
                  :type="getCustomerFieldInputType(editingCustomerField)"
                  :rules="getCustomerFieldRules(editingCustomerField)"
                  outlined
                  dense
                  autofocus
                ></v-text-field>

                <v-menu
                  v-else-if="editingCustomerField.fieldType === 'dateTime'"
                  v-model="customerFieldDateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="customerFieldEditValue"
                      :label="editingCustomerField.fieldName"
                      :rules="getCustomerFieldRules(editingCustomerField)"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      outlined
                      dense
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="customerFieldEditValue"
                    no-title
                    scrollable
                    @input="customerFieldDateMenu = false"
                  ></v-date-picker>
                </v-menu>

                <v-autocomplete
                  v-else-if="editingCustomerField.fieldType === 'Autocompletes'"
                  v-model="customerFieldEditValue"
                  :items="getCustomerFieldOptions(editingCustomerField)"
                  :label="editingCustomerField.fieldName"
                  :rules="getCustomerFieldRules(editingCustomerField)"
                  clearable
                  outlined
                  dense
                ></v-autocomplete>

                <v-select
                  v-else-if="editingCustomerField.fieldType === 'Selects'"
                  v-model="customerFieldEditValue"
                  :items="getCustomerFieldOptions(editingCustomerField)"
                  :label="editingCustomerField.fieldName"
                  :rules="getCustomerFieldRules(editingCustomerField)"
                  :multiple="editingCustomerField.multiSelect === 'True'"
                  clearable
                  outlined
                  dense
                ></v-select>

                <div v-else-if="editingCustomerField.fieldType === 'Radio'" class="queue-customer-field-choice">
                  <div class="queue-customer-field-label">{{ editingCustomerField.fieldName }}</div>
                  <v-radio-group
                    v-model="customerFieldEditValue"
                    :rules="getCustomerFieldRules(editingCustomerField)"
                    class="mt-1"
                  >
                    <v-radio
                      v-for="option in getCustomerFieldOptions(editingCustomerField)"
                      :key="String(getCustomerFieldOptionValue(option))"
                      :label="getCustomerFieldOptionText(option)"
                      :value="getCustomerFieldOptionValue(option)"
                    ></v-radio>
                  </v-radio-group>
                </div>

                <div v-else-if="editingCustomerField.fieldType === 'Checkbox'" class="queue-customer-field-choice">
                  <div class="queue-customer-field-label">{{ editingCustomerField.fieldName }}</div>
                  <v-checkbox
                    v-for="option in getCustomerFieldOptions(editingCustomerField)"
                    :key="String(getCustomerFieldOptionValue(option))"
                    v-model="customerFieldEditCheckboxValues"
                    :label="getCustomerFieldOptionText(option)"
                    :value="getCustomerFieldOptionValue(option)"
                    hide-details
                    class="mt-1"
                  ></v-checkbox>
                  <div
                    v-if="editingCustomerField.requiredField === 'True' && customerFieldEditCheckboxValues.length === 0"
                    class="queue-customer-field-required"
                  >
                    กรุณาระบุข้อมูล
                  </div>
                </div>

                <v-text-field
                  v-else
                  v-model="customerFieldEditValue"
                  :label="editingCustomerField.fieldName"
                  :rules="getCustomerFieldRules(editingCustomerField)"
                  outlined
                  dense
                ></v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions class="px-6 pb-6 pt-0">
              <v-btn
                block
                large
                dark
                color="#1B437C"
                :loading="customerFieldEditLoading"
                @click="saveCustomerFieldEdit()"
              >
                บันทึก
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogAction" persistent max-width="560px">
          <v-card>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="10" class="pt-8">
                    <h3><strong>{{ actionForm.action === 'forward_to_point' ? 'กรุณาเลือกจุดบริการ' : actionTitle }}</strong></h3>
                  </v-col>
                  <v-col cols="2" class="pt-8 text-right">
                    <v-btn fab small color="white" @click="dialogAction = false">
                      X
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row v-if="selectedBooking">
                  <v-col cols="12" class="pb-0">
                    <div class="forward-booking-summary">
                      <strong>{{ selectedBooking.storeFrontQueue || '-' }}</strong>
                      <span class="ml-2">{{ selectedBooking.bookingDataCustomerName || '-' }}</span>
                      <div class="forward-booking-subtitle">
                        บริการ: {{ selectedBooking.activeFlowName || selectedBooking.flowName || '-' }}
                        <span v-if="selectedBooking.forwardQueueNameTh"> | จุดปัจจุบัน: {{ selectedBooking.forwardQueueNameTh }}</span>
                      </div>
                    </div>
                  </v-col>
                  <template v-if="actionForm.action === 'forward_to_point'">
                    <v-col cols="12" class="pb-0 forward-dialog-section-label">
                      จุดส่งต่อ
                    </v-col>
                    <v-col cols="12" class="pb-0">
                      <v-radio-group v-model="actionForm.targetForwardQueueId" class="queue-target-grid">
                        <v-row no-gutters>
                          <v-col
                            v-for="target in availableForwardQueueItems"
                            :key="'forward-' + target.value"
                            cols="12"
                            sm="4"
                            class="queue-target-col"
                          >
                            <v-radio
                              :label="target.text"
                              :value="target.value"
                              @change="selectForwardQueueTarget()"
                            ></v-radio>
                          </v-col>
                        </v-row>
                      </v-radio-group>
                    </v-col>
                    <v-col cols="12" class="pb-0">
                      <v-divider></v-divider>
                    </v-col>
                    <v-col cols="12" class="pb-0 forward-dialog-section-label">
                      บริการ
                    </v-col>
                    <v-col cols="12" class="pb-0">
                      <v-radio-group v-model="actionForm.targetFlowId" class="queue-target-grid">
                        <v-row no-gutters>
                          <v-col
                            v-for="target in availableFlowItems"
                            :key="'flow-' + target.value"
                            cols="12"
                            sm="4"
                            class="queue-target-col"
                          >
                            <v-radio
                              :label="target.text"
                              :value="target.value"
                              @change="selectFlowTarget()"
                            ></v-radio>
                          </v-col>
                        </v-row>
                      </v-radio-group>
                    </v-col>
                  </template>
                  <v-col cols="12" v-if="actionForm.action === 'forward_to_flow'" class="pb-0">
                    <v-autocomplete
                      v-model="actionForm.targetFlowId"
                      :items="availableFlowItems"
                      label="เลือกบริการ"
                      outlined
                      dense
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" class="pb-0">
                    <v-textarea
                      v-model="actionForm.remark"
                      label="หมายเหตุ"
                      outlined
                      dense
                      rows="2"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12">
                    <v-btn block large dark color="#1B437C" @click="submitAction()">
                      {{ actionForm.action === 'forward_to_point' ? 'ส่งต่อ' : 'ยืนยัน' }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogServicePointStatus" persistent max-width="560px">
          <v-card>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="10" class="pt-8">
                    <h3><strong>กรุณาเลือกช่องบริการ</strong></h3>
                  </v-col>
                  <v-col cols="2" class="pt-8 text-right">
                    <v-btn fab small color="white" @click="dialogServicePointStatus = false">
                      X
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row v-if="selectedServicePointBooking">
                  <v-col cols="12" class="pb-0">
                    <div class="forward-booking-summary">
                      <strong>{{ selectedServicePointBooking.storeFrontQueue || '-' }}</strong>
                      <span class="ml-2">{{ selectedServicePointBooking.bookingDataCustomerName || '-' }}</span>
                      <div class="forward-booking-subtitle">
                        บริการ: {{ selectedServicePointBooking.activeFlowName || selectedServicePointBooking.flowName || '-' }}
                      </div>
                    </div>
                  </v-col>
                  <v-col v-if="servicePointOrigin" cols="12" class="pb-0">
                    <div class="return-origin-note">
                      ส่งกลับมาที่ <strong>{{ servicePointOrigin }}</strong>
                      <template v-if="isPullableReturnQueue(selectedServicePointBooking)">
                        — เลือกห้องที่ว่างเพื่อดึงคิวไปได้
                      </template>
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <v-radio-group v-model="servicePoint" row>
                      <v-row>
                        <v-col
                          v-for="(point, index) in servicePointItem"
                          :key="'service-point-' + index"
                          cols="12"
                          sm="4"
                          class="py-0"
                        >
                          <v-radio
                            :label="point.textTh + (servicePointOrigin && point.textTh === servicePointOrigin ? ' (ห้องเดิม)' : '')"
                            :value="point.textTh"
                          ></v-radio>
                        </v-col>
                      </v-row>
                    </v-radio-group>
                  </v-col>
                  <v-col cols="12">
                    <v-btn block large dark color="#1DBF73" @click="submitServicePointAction()">
                      เรียกคิว
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogHistory" max-width="720px">
          <v-card>
            <v-card-title class="queue-dialog-title">
              ประวัติส่งต่อคิว
              <v-spacer></v-spacer>
              <v-btn icon @click="dialogHistory = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <div v-if="historyBooking" class="forward-booking-summary mb-4">
                <strong>{{ historyBooking.storeFrontQueue || '-' }}</strong>
                <span class="ml-2">{{ historyBooking.bookingDataCustomerName || '-' }}</span>
                <div class="forward-booking-subtitle">
                  บริการปัจจุบัน: {{ getDisplayFlowName(historyBooking) }}
                  <span v-if="historyBooking.forwardQueueNameTh"> | จุดปัจจุบัน: {{ historyBooking.forwardQueueNameTh }}</span>
                </div>
              </div>
              <v-progress-linear v-if="historyLoading" indeterminate color="#1B437C"></v-progress-linear>
              <v-timeline v-else dense>
                <v-timeline-item
                  v-for="log in historyItems"
                  :key="log.id"
                  small
                  :color="getHistoryColor(log)"
                >
                  <div class="queue-history-title">{{ getHistoryTitle(log) }}</div>
                  <div class="queue-history-time">{{ formatLogDate(log.enterDate || log.LAST_DATE || log.CREATE_DATE) }}</div>
                  <div class="queue-history-detail">{{ getHistoryDetail(log) }}</div>
                  <div v-if="log.remark && log.actionType !== 'pull_return_queue'" class="queue-history-remark">หมายเหตุ: {{ log.remark }}</div>
                </v-timeline-item>
              </v-timeline>
              <div v-if="!historyLoading && historyItems.length === 0" class="queue-empty-state">
                ยังไม่มีประวัติการส่งต่อ
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogLine" max-width="520px">
          <v-card>
            <v-card-title class="queue-dialog-title">
              ข้อมูล LINE
              <v-spacer></v-spacer>
              <v-btn icon @click="dialogLine = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <div v-if="lineBooking" class="line-profile-card">
                <v-avatar size="72" class="mr-4">
                  <img v-if="lineBooking.memberPicture" :src="lineBooking.memberPicture" alt="LINE profile">
                  <v-icon v-else size="42" color="#25D366">mdi-account-circle</v-icon>
                </v-avatar>
                <div>
                  <div class="line-profile-name">{{ lineBooking.memberName || 'ไม่พบชื่อ LINE' }}</div>
                  <div class="line-profile-sub">คิว {{ lineBooking.storeFrontQueue || '-' }}</div>
                  <v-chip v-if="lineBooking.banStatus === 'True'" x-small color="error" dark class="mt-1">ถูกระงับ</v-chip>
                </div>
              </div>
              <v-simple-table v-if="lineBooking" dense class="mt-4 line-info-table">
                <tbody>
                  <tr>
                    <td>วันที่สมัคร</td>
                    <td>{{ formatMemberRegisterDate(lineBooking.memberCreateDate) }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogPrintSetting" max-width="640px">
          <v-card>
            <v-card-title class="queue-dialog-title">
              ตั้งค่าปริ้นบัตรคิว
              <v-spacer></v-spacer>
              <v-btn icon @click="dialogPrintSetting = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <v-select
                    v-model="printSettingForm.paperSize"
                    :items="printPaperSizeItems"
                    label="ขนาดกระดาษ"
                    outlined
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <v-textarea
                    v-model="printSettingForm.footerTextTh"
                    label="ข้อความท้ายบัตร (ไทย)"
                    :placeholder="defaultPrintFooterTh"
                    persistent-placeholder
                    outlined
                    dense
                    rows="3"
                  ></v-textarea>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <v-textarea
                    v-model="printSettingForm.footerTextEn"
                    label="ข้อความท้ายบัตร (อังกฤษ)"
                    :placeholder="defaultPrintFooterEn"
                    persistent-placeholder
                    outlined
                    dense
                    rows="3"
                  ></v-textarea>
                </v-col>
                <v-col cols="12" class="py-0">
                  <div class="queue-print-setting-hint">
                    เว้นว่างไว้ = ใช้ข้อความเริ่มต้นเหมือนเดิม · การตั้งค่านี้มีผลเฉพาะร้านนี้เท่านั้น
                  </div>
                </v-col>
                <v-col cols="12">
                  <v-btn
                    block
                    large
                    dark
                    color="#1B437C"
                    :loading="printSettingLoading"
                    @click="savePrintSetting()"
                  >
                    บันทึก
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </v-main>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment-timezone'
import pdfMake from 'pdfmake'
import pdfFonts from '../../assets/custom-fonts.js'
import printJS from 'print-js'
import JsonExcel from 'vue-json-excel'
import ModelBookingList from '../DialogModels/ModelBookingList.vue'
import lineIcon from '../../assets/lineIcon.png'

// ข้อความท้ายบัตรเริ่มต้น ใช้เมื่อร้านยังไม่ได้ตั้งค่าเอง (ของเดิมก่อนมีตั้งค่ารายร้าน)
const DEFAULT_PRINT_FOOTER_TH = 'หากท่านไม่ได้อยู่ในช่วงที่มีการเรียกคิว สามารถแจ้งหมายเลขคิวกับพนักงาน เพื่อยืนยันการเข้ารับบริการได้ค่ะ'
const DEFAULT_PRINT_FOOTER_EN = 'If you are away when called, please show this queue number to staff for service confirmation.'

// สเปกตั๋วคิวของเครื่อง POS (window_select_queue/src/renderer.js) หน่วย pt = px ของ POS x 0.75
// (โลโก้ 200px, ชื่อบริการ 14px, เลขคิว 68px, บรรทัดรอง 12px, QR 155px, ท้ายบัตร 10px, margin 6px/4px)
const POS_TICKET_BASE = {
  logoWidth: 150,
  flowName: 10.5,
  queueNo: 51,
  secondary: 9,
  qr: 116.25,
  customer: 9,
  footerNote: 7.5,
  gap: 4.5,
  gapSmall: 3
}

// สลิป 80mm = กระดาษ 80mm (226.77pt) เว้นขอบข้างละ 4mm ให้เนื้อหากว้าง 72mm เท่าพื้นที่พิมพ์จริงของหัวพิมพ์
const POS_TICKET_80MM_PAGE = {
  scale: 1,
  pageSize: { width: 226.77, height: 'auto' },
  pageMargins: [11.34, 8, 11.34, 8]
}

export default {
  components: {
    ModelBookingList,
    downloadExcel: JsonExcel
  },
  data () {
    return {
      session: this.$session.getAll(),
      shopId: this.$session.getAll().data.shopId,
      loading: false,
      submittingActionKeys: [], // กันกดปุ่มเดิมรัว ๆ ระหว่างยังส่งไม่เสร็จ (double-submit)
      menuStart: false,
      dateStart: moment().format('YYYY-MM-DD'),
      mode: 'department',
      modeItems: [
        { text: 'แผนก', value: 'department' },
        { text: 'จุดส่งต่อ', value: 'forward_point' }
      ],
      masBranchID: '',
      branchItem: [],
      flowSelect: '',
      flowItems: [],
      forwardQueueSelect: '',
      forwardQueueItems: [],
      overviewItems: [],
      itemBooking: [],
      search: '',
      dialogAction: false,
      dialogHistory: false,
      dialogLine: false,
      dialogServicePointStatus: false,
      dialogCustomerFieldEdit: false,
      dialogPrintSetting: false,
      printSettingLoading: false,
      printConfig: {},
      printSettingForm: {
        paperSize: 'A4',
        footerTextTh: '',
        footerTextEn: ''
      },
      printPaperSizeItems: [
        { text: 'A4 (ค่าเริ่มต้น)', value: 'A4' },
        { text: 'สลิป 80mm (ขนาดเท่าเครื่อง POS)', value: '80mm' }
      ],
      defaultPrintFooterTh: DEFAULT_PRINT_FOOTER_TH,
      defaultPrintFooterEn: DEFAULT_PRINT_FOOTER_EN,
      customerFieldEditValid: true,
      customerFieldEditLoading: false,
      customerFieldDateMenu: false,
      editingCustomerField: {},
      editingCustomerFieldBooking: null,
      customerFieldEditValue: '',
      customerFieldEditCheckboxValues: [],
      selectedBooking: null,
      selectedServicePointBooking: null,
      historyBooking: null,
      historyItems: [],
      historyLoading: false,
      lineBooking: null,
      actionForm: {
        action: '',
        targetType: 'forward_queue',
        targetForwardQueueId: '',
        targetFlowId: '',
        remark: ''
      },
      breadcrumbs: [
        { text: 'Home', disabled: false, href: '/Core/Home' },
        { text: 'จัดการคิวส่งต่อ', disabled: true }
      ],
      customerFieldNames: [],
      customFieldData: [],
      bookingFieldData: {},
      bookingDataView: {},
      dataLineConfig: {},
      servicePoint: '',
      servicePointItem: [],
      servicePointOrigin: '',
      queueType: 'all',
      queueTypeItems: [
        { text: 'คิวทั้งหมด', value: 'all' },
        { text: 'คิวที่ยังไม่ได้ปิดงาน', value: 'open' },
        { text: 'คิวที่ปิดงานแล้ว', value: 'closed' }
      ],
      exportWorksheet: 'BookingForwardQueue',
      firestore: null,
      unsubscribeForwardQueueRealtime: null,
      forwardQueueRealtimeStartedAt: null,
      lastForwardQueueRealtimeVersion: null,
      lineIcon: lineIcon
    }
  },
  computed: {
    // ประตูของฟีเจอร์เรียกคิวพร้อมกัน — ลิสต์ร้านอยู่ที่ src/main.js ที่เดียว
    simultaneousCallEnabled () {
      return this.$isSimultaneousCallShop(this.shopId)
    },
    forwardingUserTypeConfig () {
      const userType = this.parseUserTypeJson((this.session.data && this.session.data.user_type) || this.session.user_type)
      return userType.forwarding_queue || null
    },
    shouldApplyForwardingUserType () {
      const config = this.forwardingUserTypeConfig
      if (!config || !config.targetType) return false
      // จำกัด scope เฉพาะ role storeFront เหมือน prod เดิม — role อื่น (เช่น user ห้องยา)
      // ต้องเห็นครบทั้งโหมดแผนกและจุดส่งต่อ ไม่ถูก filter dropdown โหมด
      if (this.session.data && this.session.data.USER_ROLE !== 'storeFront') return false
      return this.isForwardingQueueEnabled()
    },
    // สิทธิ์ "เห็นเฉพาะห้องตัวเอง" — คนละเรื่องกับ dropdown โหมดข้างบน
    // storeFront ใช้ของเดิมทุกร้าน ส่วน role อื่น (เช่น user ประจำห้อง) เพิ่งเริ่มถูกจำกัด
    // จึงกันไว้เฉพาะร้านที่เปิดเรียกคิวพร้อมกันแล้ว ร้านอื่นได้พฤติกรรมเดิมทุกจุด
    shouldFilterQueueByUserType () {
      if (this.shouldApplyForwardingUserType) return true
      if (!this.simultaneousCallEnabled) return false
      const config = this.forwardingUserTypeConfig
      if (!config || !config.targetType) return false
      if (this.session.data && this.session.data.USER_ROLE === 'admin') return false
      const scopeList = config.targetType === 'forward_queue' ? config.forwardQueueIdList : config.flowIdList
      if (!Array.isArray(scopeList) || scopeList.length === 0) return false
      return this.isForwardingQueueEnabled()
    },
    userServicePointList () {
      if (!this.shouldFilterQueueByUserType) return []
      const config = this.forwardingUserTypeConfig
      if (config.targetType === 'forward_queue') return []
      const servicePoints = []
      ;(config.flowServicePointMap || []).forEach(function (mapData) {
        ;(mapData.servicePointList || []).forEach(function (point) {
          const pointName = String(point).trim()
          if (pointName && servicePoints.indexOf(pointName) === -1) servicePoints.push(pointName)
        })
      })
      return servicePoints
    },
    hasFullServicePointAccessAllFlows () {
      if (!this.shouldFilterQueueByUserType) return true
      const config = this.forwardingUserTypeConfig
      if (config.targetType === 'forward_queue') return true
      const flowServicePointMap = config.flowServicePointMap || []
      if (flowServicePointMap.length === 0) return true
      return flowServicePointMap.every(function (mapData) {
        const allowedServicePoints = (mapData.servicePointList || []).map(function (point) {
          return String(point).trim()
        })
        const flowItem = this.flowItems.filter(function (flow) {
          return String(flow.value) === String(mapData.flowId)
        })[0]
        if (!flowItem || !flowItem.allData) return false
        return this.hasFullServicePointAccess(allowedServicePoints, flowItem.allData.servicePointCount)
      }, this)
    },
    availableModeItems () {
      if (!this.shouldApplyForwardingUserType) return this.modeItems
      if (this.forwardingUserTypeConfig.targetType === 'forward_queue') {
        return this.modeItems.filter(function (item) { return item.value === 'forward_point' })
      }
      return this.modeItems.filter(function (item) { return item.value === 'department' })
    },
    tableHeaders () {
      const fieldHeaders = this.customerFieldNames
        .filter(function (field) {
          return field.fieldName !== 'บริการ' && field.fieldName !== 'ประเภทบริการ'
        })
        .map(function (field) {
          return {
            text: field.fieldName,
            value: 'field_' + field.fieldId
          }
        })

      return [
        { text: 'คิว', value: 'storeFrontQueue' },
        { text: 'บริการ', value: 'activeFlowName' },
        // { text: 'จุดส่งต่อ', value: 'forwardQueueNameTh' },
        { text: 'ช่องบริการ', value: 'servicePoint' }
        // { text: 'ลูกค้า', value: 'customer' }
      ].concat(fieldHeaders, [
        { text: this.mode === 'department' ? 'เวลาล่าสุด' : 'เวลาเข้าจุด', value: 'queueTimeText' },
        { text: 'ปริ้นคิว', value: 'actionPrint', sortable: false, align: 'center', width: '140px' },
        { text: 'จัดการ', value: 'actions', sortable: false, width: '420px' }
      ])
    },
    flowItemsOnly () {
      return this.flowItems
    },
    actionTitle () {
      const titleMap = {
        forward_to_point: 'ส่งต่อจุดบริการ',
        return_to_flow: 'ส่งกลับบริการ',
        forward_to_flow: 'ส่งต่อบริการ',
        call_queue: 'เรียกคิว',
        recall_queue: 'เรียกคิวซ้ำ',
        finish: 'เสร็จสิ้น',
        cancel_queue: 'ยกเลิกคิว',
        close: 'ปิดงาน',
        cancel: 'ยกเลิก'
      }
      return titleMap[this.actionForm.action] || 'จัดการคิว'
    },
    availableForwardQueueItems () {
      if (!this.selectedBooking) return this.forwardQueueItems
      const flowId = String(this.selectedBooking.activeFlowId || this.selectedBooking.currentFlowId || this.selectedBooking.flowId)
      const selectableItems = this.forwardQueueItems.filter(function (item) {
        const allData = item.allData || {}
        if (String(allData.id) === String(this.selectedBooking.forwardQueueId)) return false
        if ((allData.applyAllFlow || 'True') === 'True') return true
        let flowIdList = []
        try {
          flowIdList = JSON.parse(allData.flowIdList || '[]')
        } catch (error) {
          flowIdList = []
        }
        return flowIdList.map(String).indexOf(flowId) > -1
      }, this)
      if (selectableItems.length > 0) return selectableItems
      return this.forwardQueueItems.filter(function (item) {
        const allData = item.allData || {}
        return String(allData.id) !== String(this.selectedBooking.forwardQueueId)
      }, this)
    },
    availableFlowItems () {
      if (!this.selectedBooking) return this.flowItems
      const flowId = String(this.selectedBooking.activeFlowId || this.selectedBooking.flowId)
      return this.flowItems.filter(function (item) {
        const allData = item.allData || {}
        return String(item.value) !== flowId && (allData.isForwardQueue || 'False') === 'True'
      })
    },
    overviewDisplayItems () {
      const displayItems = this.filterOverviewItemsByUserType(this.overviewItems)
      const total = displayItems.reduce(function (sum, item) {
        return sum + (parseInt(item.countQueue) || 0)
      }, 0)
      return [{
        id: 'all',
        flowId: 'all',
        forwardQueueId: 'all',
        flowName: 'ทั้งหมด',
        forwardQueueNameTh: 'ทั้งหมด',
        countQueue: total,
        isAll: true
      }].concat(displayItems)
    },
    exportFields () {
      const fields = {
        'คิว': 'storeFrontQueue',
        'บริการ': 'activeFlowName',
        'จุดส่งต่อ': 'forwardQueueNameTh',
        'ช่องบริการ': 'servicePoint'
      }
      this.customerFieldNames
        .filter(function (field) {
          return field.fieldName !== 'บริการ' && field.fieldName !== 'ประเภทบริการ'
        })
        .forEach(function (field) {
          fields[field.fieldName] = 'field_' + field.fieldId
        })
      fields[this.mode === 'department' ? 'เวลาล่าสุด' : 'เวลาเข้าจุด'] = 'queueTimeText'
      fields['ชื่อลูกค้า'] = 'bookingDataCustomerName'
      fields['เบอร์โทร'] = 'bookingDataCustomerTel'
      fields['สถานะ'] = 'queueStatusText'
      return fields
    },
    exportData () {
      const rows = this.itemBooking.map(function (item) {
        const row = {
          storeFrontQueue: item.storeFrontQueue || '-',
          activeFlowName: this.getDisplayFlowName(item),
          forwardQueueNameTh: item.forwardQueueNameTh || '-',
          servicePoint: item.servicePoint || '-',
          queueTimeText: this.getQueueTimeText(item),
          bookingDataCustomerName: item.bookingDataCustomerName || '-',
          bookingDataCustomerTel: item.bookingDataCustomerTel || '-',
          queueStatusText: this.isTerminalQueueStatus(item)
            ? this.getTerminalQueueStatusText(item)
            : this.isForwardPointCalled(item) ? 'เรียกคิวแล้ว' : 'รอเรียกคิว'
        }
        this.customerFieldNames.forEach(function (field) {
          row['field_' + field.fieldId] = item['field_' + field.fieldId] || '-'
        })
        return row
      }, this)
      if (!this.search) return rows
      const searchText = String(this.search).toLowerCase()
      return rows.filter(function (row) {
        return Object.keys(row).some(function (key) {
          return String(row[key] || '').toLowerCase().indexOf(searchText) > -1
        })
      })
    },
    exportFileName () {
      return 'BookingForwardQueue_' + this.mode + '_' + this.dateStart + '.xls'
    }
  },
  async mounted () {
    this.dataLineConfig = await this.getDataLineConfig(this.shopId)
    await this.getPrintConfig()
    await this.getBranch()
    await this.getFlow()
    await this.getForwardQueue()
    await this.getCustomFieldStart()
    this.applyForwardingUserTypeDefault()
    await this.loadData()
    this.getForwardQueueRealtimeFirestore()
  },
  beforeDestroy () {
    if (this.unsubscribeForwardQueueRealtime) {
      this.unsubscribeForwardQueueRealtime()
      this.unsubscribeForwardQueueRealtime = null
    }
  },
  methods: {
    getForwardQueueRealtimeDocRef () {
      if (!this.$firebase || !this.shopId || !this.masBranchID) return null
      if (!this.firestore) this.firestore = this.$firebase.firestore()
      return this.firestore.collection('ForwardQueueRealtime/shopId/' + this.shopId).doc(String(this.masBranchID))
    },
    getForwardQueueRealtimeTime (value) {
      if (!value) return 0
      if (typeof value.toDate === 'function') return value.toDate().getTime()
      const dateValue = new Date(value).getTime()
      return isNaN(dateValue) ? 0 : dateValue
    },
    getForwardQueueRealtimeFirestore () {
      try {
        if (this.unsubscribeForwardQueueRealtime) {
          this.unsubscribeForwardQueueRealtime()
          this.unsubscribeForwardQueueRealtime = null
        }
        const docRef = this.getForwardQueueRealtimeDocRef()
        if (!docRef) return
        this.forwardQueueRealtimeStartedAt = new Date()
        this.lastForwardQueueRealtimeVersion = null
        this.unsubscribeForwardQueueRealtime = docRef.onSnapshot(async (snapshot) => {
          if (!snapshot.exists) return
          const data = snapshot.data() || {}
          const eventTime = this.getForwardQueueRealtimeTime(data.updatedAt)
          const startedAt = this.forwardQueueRealtimeStartedAt ? this.forwardQueueRealtimeStartedAt.getTime() : 0
          if (eventTime && startedAt && eventTime < startedAt) {
            this.lastForwardQueueRealtimeVersion = data.version || null
            return
          }
          if (data.version && this.lastForwardQueueRealtimeVersion === data.version) return
          this.lastForwardQueueRealtimeVersion = data.version || null
          await this.loadData()
        })
      } catch (error) {
        console.log('getForwardQueueRealtimeFirestore error', error)
      }
    },
    async notifyForwardQueueRealtime (item, action, extraData) {
      let body = null
      try {
        if (!this.shopId || !this.masBranchID) return
        const targetType = extraData && extraData.targetType ? extraData.targetType : this.getForwardQueueRealtimeTargetType(item, action)
        body = {
          shopId: this.shopId,
          masBranchID: this.masBranchID,
          eventType: action,
          mode: this.mode,
          targetType: targetType,
          bookNo: item && item.bookNo,
          bookingId: item && item.bookingId,
          queueNo: item && item.storeFrontQueue,
          flowId: (extraData && extraData.flowId) || (item && (item.activeFlowId || item.currentFlowId || item.flowId)),
          flowName: (extraData && extraData.flowName) || (item && this.getDisplayFlowName(item)),
          forwardQueueId: (extraData && extraData.forwardQueueId) || (item && item.forwardQueueId),
          forwardQueueName: (extraData && extraData.forwardQueueName) || (item && (item.forwardQueueNameTh || item.forwardQueueNameEn)),
          statusSound: extraData && typeof extraData.statusSound !== 'undefined'
            ? extraData.statusSound
            : this.shouldForwardQueueEventPlaySound(action, targetType)
        }
        await axios.post('https://asia-southeast1-be-linked-a7cdc.cloudfunctions.net/ForwardQueueRealtime-ProcessNew', body)
      } catch (error) {
        console.log('notifyForwardQueueRealtime function error', error)
        await this.notifyForwardQueueRealtimeFirestoreFallback(body)
      }
    },
    async notifyForwardQueueRealtimeFirestoreFallback (body) {
      try {
        const docRef = this.getForwardQueueRealtimeDocRef()
        if (!docRef) return
        const fallbackBody = Object.assign({}, body, {
          updatedAt: new Date(),
          version: new Date().getTime()
        })
        await docRef.set(fallbackBody, { merge: true })
        console.log('notifyForwardQueueRealtime fallback success', fallbackBody)
      } catch (error) {
        console.log('notifyForwardQueueRealtime fallback error', error)
      }
    },
    getForwardQueueRealtimeTargetType (item, action) {
      if (action === 'forward_to_point' || action === 'return_to_flow') return 'forward_queue'
      if (action === 'forward_to_flow') return 'flow'
      return this.mode === 'department' ? 'flow' : 'forward_queue'
    },
    shouldForwardQueueEventPlaySound (action, targetType) {
      return (action === 'call_queue' || action === 'recall_queue') && targetType === 'flow'
    },
    // คืน true = เรียกพร้อมเสียง, false = เรียกแบบไม่มีเสียง, null = ไม่ต้องถาม
    // undefined = ผู้ใช้ปิด dialog ทิ้ง (คลิกนอกกล่อง/Esc) โดยไม่เลือกอะไร -> ยกเลิกการเรียกคิวทั้งหมด
    async confirmReturnedQueueSound (item, action) {
      if (action !== 'call_queue' || !this.isReturnedQueue(item) || !this.getReturnedQueueName(item)) return null
      try {
        const response = await this.$swal({
          title: 'ต้องการเรียกเสียงคิวไหม?',
          text: 'คิวนี้ถูกส่งกลับมาที่บริการ "เรียกเสียง" = ประกาศเสียง+ขึ้นจอ TV, "ไม่เรียกเสียง" = ขึ้นจอ TV อย่างเดียวไม่ประกาศเสียง',
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#1DBF73',
          cancelButtonColor: '#F38383',
          confirmButtonText: 'เรียกเสียง',
          cancelButtonText: 'ไม่เรียกเสียง'
        })
        return !!(response && (response.value || response === true))
      } catch (error) {
        // sweetalert2 v6 reject ตอน dismiss ทุกแบบ: 'cancel' = ปุ่ม "ไม่เรียกเสียง", 'overlay'/'esc'/'close' = ปิดทิ้ง
        return error === 'cancel' ? false : undefined
      }
    },
    isLineUserId (item) {
      const userId = item && item.userId ? item.userId : ''
      return !!(userId && userId !== 'user-skip' && userId !== 'data import' && userId !== '-')
    },
    async notifyLineQueue (item, action, targetType) {
      try {
        if (action !== 'call_queue' && action !== 'recall_queue') return
        if (!this.isLineUserId(item)) return
        await axios.post(this.$DNS_IP + '/booking_forward_queue/pushMsgQueue/' + item.bookNo, {
          action: action,
          targetType: targetType || this.getForwardQueueRealtimeTargetType(item, action),
          mode: this.mode
        })
      } catch (error) {
        console.log('notifyLineQueue error', error)
      }
    },
    async notifyBeforeLineQueue (item, action) {
      try {
        if (action !== 'call_queue' && action !== 'recall_queue') return
        if (item.forwardQueueId) return
        if ((item.storeFrontNotifyStatus || 'False') !== 'True') return
        const countNoti = parseInt(item.storeFrontNotifySet || 0)
        if (!countNoti || countNoti <= 0) return
        await axios.post(this.$DNS_IP + '/booking_forward_queue/pushBeforeQueue/' + item.bookNo, {
          countNoti: countNoti
        })
      } catch (error) {
        console.log('notifyBeforeLineQueue error', error)
      }
    },
    parseServicePointCount (item) {
      if (!item || !item.servicePointCount) return []
      if (Array.isArray(item.servicePointCount)) return item.servicePointCount
      try {
        const data = JSON.parse(item.servicePointCount)
        return Array.isArray(data) ? data : []
      } catch (error) {
        return []
      }
    },
    getAllowedServicePointList (item) {
      const config = this.forwardingUserTypeConfig
      if (!config || !Array.isArray(config.flowServicePointMap)) return []
      const flowId = String(item.activeFlowId || item.currentFlowId || item.flowId)
      const mapData = config.flowServicePointMap.filter(function (row) {
        return String(row.flowId) === flowId
      })[0]
      if (!mapData || !Array.isArray(mapData.servicePointList)) return []
      return mapData.servicePointList
    },
    filterServicePointItemsByUserType (items, item) {
      if (!this.shouldFilterQueueByUserType) return items
      const allowedServicePoints = this.getAllowedServicePointList(item)
      if (allowedServicePoints.length === 0) return items
      return items.filter(function (point) {
        return allowedServicePoints.indexOf(point.textTh || point.textEn) > -1
      })
    },
    shouldSelectServicePoint (item, action) {
      return this.mode === 'department' && action === 'call_queue' && item && item.servicePointStatus === 'True'
    },
    async openServicePointDialog (item) {
      this.selectedServicePointBooking = item
      this.servicePoint = item.servicePoint || ''
      const isParked = this.simultaneousCallEnabled && this.isReturnedParkedQueue(item)
      const originPoint = String(item.servicePoint || '').trim()
      let allPoints = this.filterServicePointItemsByUserType(this.parseServicePointCount(item), item)
      if (isParked && !this.isPullableReturnQueue(item)) {
        allPoints = this.parseServicePointCount(item).filter(function (point) {
          return String(point.textTh || point.textEn || '').trim() === originPoint
        })
      }
      this.servicePointItem = allPoints
      this.servicePointOrigin = isParked ? originPoint : ''
      if (isParked || item.servicePointRecursive === 'False' || this.getSimultaneousCallLimit(item) > 1) {
        await this.setServicePointCount(item, allPoints)
      }
      if (isParked && !this.servicePoint && this.servicePointItem.length === 1) {
        this.servicePoint = this.servicePointItem[0].textTh
      }
      if (isParked && this.servicePointItem.length === 0) {
        this.$swal(
          'แจ้งเตือน',
          this.isPullableReturnQueue(item)
            ? 'ห้องที่คุณเรียกได้เต็มทุกห้อง รอห้องว่างก่อน'
            : originPoint + ' ยังเต็ม รอห้องว่างก่อน (บริการนี้ยังไม่เปิดให้ห้องอื่นดึงคิวส่งกลับ)',
          'info'
        )
        return
      }
      if (this.servicePointItem.length === 0) {
        // แยกให้ชัดว่า "ไม่มีห้องตั้งไว้เลย" กับ "มีห้องแต่รับครบรอบแล้ว" คนละเรื่องกัน
        const isFull = allPoints.length > 0
        this.$swal(
          'แจ้งเตือน',
          isFull
            ? 'รอบบริการครบ ' + this.getSimultaneousCallLimit(item) + ' แล้ว'
            : 'ยังไม่มีช่องบริการให้เลือก',
          'info'
        )
        return
      }
      this.dialogServicePointStatus = true
    },
    getSimultaneousCallLimit (item) {
      if (!item || (item.is_simultaneous_call || 'False') !== 'True') return 1
      const limit = parseInt(item.simultaneous_call_limit) || 0
      return limit > 0 ? limit : 1
    },
    async setServicePointCount (item, baseItems) {
      const defaultItems = baseItems || this.filterServicePointItemsByUserType(this.parseServicePointCount(item), item)
      this.servicePointItem = defaultItems
      if (defaultItems.length === 0) return
      try {
        const params = [
          'shopId=' + this.shopId,
          'dueDate=' + this.dateStart
        ]
        if (this.masBranchID) params.push('masBranchID=' + this.masBranchID)
        if ((item.is_simultaneous_call || 'False') !== 'True') {
          const flowId = item.activeFlowId || item.currentFlowId || item.flowId
          if (flowId) params.push('flowId=' + flowId)
        }
        const response = await axios.get(this.$DNS_IP + '/booking_forward_queue/getQueueTV?' + params.join('&'))
        const responseData = response.data || {}
        const data = responseData.status
          ? (responseData.dataService || responseData.data_service || [])
          : []
        const usedServicePoints = Array.isArray(data)
          ? data
            .filter(function (row) {
              return row.bookNo !== item.bookNo && row.servicePoint
            })
            .map(function (row) {
              return String(row.servicePoint).trim()
            })
          : []
        const pointLimit = this.getSimultaneousCallLimit(item)
        // ห้องที่คิวครองอยู่แล้วเลือกซ้ำได้ แต่คิวส่งกลับที่ยังไม่ถูกเรียกยังไม่ได้ครอง ต้องเช็กโควตาเหมือนคิวอื่น
        const keepOwnPoint = !!item.call_queue_date_time || !this.simultaneousCallEnabled
        const availableItems = defaultItems.filter(function (point) {
          const pointName = String(point.textTh || point.textEn || '').trim()
          if (keepOwnPoint && pointName === String(item.servicePoint || '').trim()) return true
          const used = usedServicePoints.filter(function (usedName) {
            return usedName === pointName
          }).length
          return used < pointLimit
        })
        this.servicePointItem = availableItems
        if (this.servicePoint && !availableItems.some(point => String(point.textTh || point.textEn || '').trim() === String(this.servicePoint).trim())) {
          this.servicePoint = ''
        }
      } catch (error) {
        console.log('setServicePointCount error', error)
        this.servicePointItem = defaultItems
      }
    },
    async submitServicePointAction () {
      if (!this.selectedServicePointBooking) return
      if (!this.servicePoint) {
        this.$swal('แจ้งเตือน', 'กรุณาเลือกช่องบริการ', 'info')
        return
      }
      await this.submitDirectAction(this.selectedServicePointBooking, 'call_queue', {
        servicePoint: this.servicePoint
      })
      this.dialogServicePointStatus = false
      this.selectedServicePointBooking = null
      this.servicePoint = ''
    },
    getForwardQueueTargetData (targetForwardQueueId) {
      const data = this.forwardQueueItems.filter(function (item) {
        return String(item.value) === String(targetForwardQueueId)
      })
      if (data.length === 0) return {}
      const allData = data[0].allData || {}
      return {
        forwardQueueId: data[0].value,
        forwardQueueName: data[0].text,
        isAutoCallQueue: allData.isAutoCallQueue || 'False',
        isCallQueueSound: allData.isCallQueueSound || 'False'
      }
    },
    getFlowTargetData (targetFlowId) {
      const data = this.flowItems.filter(function (item) {
        return String(item.value) === String(targetFlowId)
      })
      if (data.length === 0) return {}
      return {
        flowId: data[0].value,
        flowName: data[0].text
      }
    },
    parseUserTypeJson (userType) {
      if (!userType || userType === 'null' || userType === 'None') return {}
      if (typeof userType === 'object') return userType
      try {
        return JSON.parse(userType)
      } catch (error) {
        return {}
      }
    },
    isForwardingQueueEnabled () {
      const value = (this.session.data && this.session.data.is_forwarding_queue) || this.session.is_forwarding_queue
      return value === true || value === 'True' || value === 'true'
    },
    applyForwardingUserTypeDefault () {
      if (!this.shouldApplyForwardingUserType) return
      if (this.forwardingUserTypeConfig.targetType === 'forward_queue') {
        this.mode = 'forward_point'
      } else {
        this.mode = 'department'
      }
    },
    filterOverviewItemsByUserType (items) {
      if (!this.shouldFilterQueueByUserType) return items
      const config = this.forwardingUserTypeConfig
      if (config.targetType === 'forward_queue') {
        const allowedIds = (config.forwardQueueIdList || []).map(String)
        return items.filter(function (item) {
          return allowedIds.indexOf(String(item.id || item.forwardQueueId)) > -1
        })
      }
      const allowedFlowIds = (config.flowIdList || []).map(String)
      return items.filter(function (item) {
        return allowedFlowIds.indexOf(String(item.flowId || item.id)) > -1
      })
    },
    getFlowServicePointNames (servicePointCount) {
      return this.parseServicePointCount({ servicePointCount: servicePointCount })
        .map(function (point) {
          return String(point.textTh || point.textEn || '').trim()
        })
        .filter(function (pointName) {
          return !!pointName
        })
    },
    hasFullServicePointAccess (allowedServicePoints, servicePointCount) {
      if (allowedServicePoints.length === 0) return true
      const flowServicePoints = this.getFlowServicePointNames(servicePointCount)
      if (flowServicePoints.length === 0) return true
      return flowServicePoints.every(function (pointName) {
        return allowedServicePoints.indexOf(pointName) > -1
      })
    },
    isQueueWaitingToBeCalled (item) {
      if (this.isTerminalQueueStatus(item)) return false
      return !this.isDepartmentQueueCalled(item)
    },
    isServicePointAllowed (item) {
      const allowedServicePoints = this.getAllowedServicePointList(item).map(function (point) {
        return String(point).trim()
      })
      if (allowedServicePoints.length === 0) return true
      const servicePoint = String(item.servicePoint || '').trim()
      if (this.isPullableReturnQueue(item)) return true
      if (servicePoint) return allowedServicePoints.indexOf(servicePoint) > -1
      if (this.hasFullServicePointAccess(allowedServicePoints, item.servicePointCount)) return true
      return this.isQueueWaitingToBeCalled(item)
    },
    filterBookingItemsByUserType (items) {
      if (!this.shouldFilterQueueByUserType) return items
      const config = this.forwardingUserTypeConfig
      if (config.targetType === 'forward_queue') {
        const allowedIds = (config.forwardQueueIdList || []).map(String)
        return items.filter(function (item) {
          return allowedIds.indexOf(String(item.forwardQueueId)) > -1
        })
      }
      const allowedFlowIds = (config.flowIdList || []).map(String)
      return items.filter(function (item) {
        if (allowedFlowIds.indexOf(String(item.activeFlowId || item.currentFlowId || item.flowId)) === -1) return false
        return this.isServicePointAllowed(item)
      }, this)
    },
    async getBranch () {
      await axios
        .get(this.$DNS_IP + '/master_branch/get?shopId=' + this.shopId)
        .then(response => {
          const data = Array.isArray(response.data) ? response.data : []
          this.branchItem = data.map(function (item) {
            return {
              text: item.masBranchName,
              value: item.masBranchID
            }
          })
          if (this.branchItem.length > 0) {
            this.masBranchID = this.branchItem[0].value
          }
        })
    },
    async getFlow () {
      const params = [
        'shopId=' + this.shopId,
        'storeFrontCheck=True',
        'isShow=all'
      ]
      if (this.masBranchID) params.push('masBranchIDAll=' + this.masBranchID)
      await axios
        .get(this.$DNS_IP + '/flow/get?' + params.join('&'))
        .then(response => {
          const data = Array.isArray(response.data) ? response.data : []
          const flowItems = data
            .filter(function (item) { return item.isShow !== 'False' })
            .map(function (item) {
              return {
                text: item.flowName,
                value: item.flowId,
                allData: item
              }
            })
          this.flowItems = flowItems
        })
    },
    async getForwardQueue () {
      await axios
        .get(this.$DNS_IP + '/forward_queue/get?shopId=' + this.shopId)
        .then(response => {
          const data = Array.isArray(response.data) ? response.data : []
          this.forwardQueueItems = data
            .filter(function (item) { return (item.isShow || 'True') === 'True' })
            .map(function (item) {
              return {
                text: item.forwardQueueNameTh,
                value: item.id,
                allData: item
              }
            })
        })
    },
    async getCustomFieldStart () {
      this.customerFieldNames = []
      const flowfieldNameCustomer = await this.getBookingFieldData()
      const customerFieldIds = flowfieldNameCustomer.map(function (item) {
        return item.fieldId
      })

      await axios
        .get(this.$DNS_IP + '/customField/get?shopId=' + this.shopId)
        .then(response => {
          const data = Array.isArray(response.data) ? response.data : []
          this.customFieldData = data
          this.customerFieldNames = data
            .filter(function (field) {
              return customerFieldIds.indexOf(field.fieldId) > -1 && field.fieldType !== 'Arguments'
            })
            .map(function (field) {
              return {
                fieldId: field.fieldId,
                fieldName: field.fieldName,
                fieldNameEn: field.fieldNameEn,
                fieldType: field.fieldType,
                optionField: field.optionField,
                multiSelect: field.multiSelect,
                requiredField: field.requiredField,
                conditionField: field.conditionField,
                conditionValue: field.conditionValue
              }
            })
        })
        .catch(error => {
          console.log('getCustomFieldStart error', error)
        })
    },
    async getBookingFieldData () {
      try {
        const response = await axios.get(this.$DNS_IP + '/BookingField/get?shopId=' + this.shopId)
        const data = Array.isArray(response.data) ? response.data : []
        if (data.length > 0) {
          this.bookingFieldData = data[0]
          if (this.bookingFieldData.flowfieldNameCustomer) {
            return JSON.parse(this.bookingFieldData.flowfieldNameCustomer)
          }
        }
      } catch (error) {
        console.log('getBookingFieldData error', error)
      }
      return []
    },
    async getBookingDataView () {
      this.bookingDataView = {}
      if (!this.masBranchID || !this.dateStart) return
      const params = [
        'shopId=' + this.shopId,
        'masBranchID=' + this.masBranchID,
        'dueDate=' + this.dateStart
      ]
      await axios
        .get(this.$DNS_IP + '/BookingData/getView?' + params.join('&'))
        .then(response => {
          const data = Array.isArray(response.data) ? response.data : []
          const bookingDataView = {}
          data.forEach(function (row) {
            if (typeof bookingDataView[row.bookNo] === 'undefined') bookingDataView[row.bookNo] = []
            bookingDataView[row.bookNo].push(row)
          })
          this.bookingDataView = bookingDataView
        })
        .catch(error => {
          console.log('getBookingDataView error', error)
        })
    },
    async loadData () {
      this.loading = true
      await this.getBookingDataView()
      await this.getOverview()
      const params = [
        'shopId=' + this.shopId,
        'mode=' + this.mode,
        'dueDate=' + this.dateStart
      ]
      if (this.masBranchID) params.push('masBranchID=' + this.masBranchID)
      if (this.flowSelect) params.push('flowId=' + this.flowSelect)
      if (this.forwardQueueSelect) params.push('forwardQueueId=' + this.forwardQueueSelect)
      if (this.search) params.push('search=' + encodeURIComponent(this.search))
      if (this.simultaneousCallEnabled && this.queueType !== 'all') params.push('queueType=' + this.queueType)
      await axios
        .get(this.$DNS_IP + '/booking_forward_queue/list?' + params.join('&'))
        .then(response => {
          const data = response.data && response.data.status ? response.data.data : []
          this.itemBooking = this.filterBookingItemsByUserType(data).map(item => this.decorateBookingRow(item))
        })
        .catch(error => {
          console.log('loadData booking_forward_queue error', error)
          this.itemBooking = []
        })
      this.loading = false
    },
    async getOverview () {
      const params = [
        'shopId=' + this.shopId,
        'mode=' + this.mode,
        'dueDate=' + this.dateStart
      ]
      if (this.masBranchID) params.push('masBranchID=' + this.masBranchID)
      const userServicePoints = this.userServicePointList
      if (this.mode === 'department' && userServicePoints.length > 0) {
        params.push('servicePoints=' + encodeURIComponent(JSON.stringify(userServicePoints)))
        if (this.hasFullServicePointAccessAllFlows) params.push('includeReturnedNoServicePoint=True')
      }
      await axios
        .get(this.$DNS_IP + '/booking_forward_queue/overview?' + params.join('&'))
        .then(response => {
          this.overviewItems = response.data && response.data.status ? response.data.data : []
        })
        .catch(error => {
          console.log('overview error', error)
          this.overviewItems = []
        })
    },
    async changeBranch () {
      this.flowSelect = ''
      this.forwardQueueSelect = ''
      await this.getFlow()
      await this.loadData()
      this.getForwardQueueRealtimeFirestore()
    },
    changeMode () {
      this.flowSelect = ''
      this.forwardQueueSelect = ''
      this.loadData()
    },
    overviewName (item) {
      if (item.isAll) return 'ทั้งหมด'
      if (this.mode === 'department') return item.flowName || item.flowNameEn || '-'
      return item.forwardQueueNameTh || item.forwardQueueNameEn || '-'
    },
    isSelectedOverview (item) {
      if (item.isAll) {
        return this.mode === 'department' ? this.flowSelect === '' : this.forwardQueueSelect === ''
      }
      if (this.mode === 'department') return String(this.flowSelect) === String(item.flowId || item.id)
      return String(this.forwardQueueSelect) === String(item.id)
    },
    selectOverview (item) {
      if (item.isAll) {
        this.flowSelect = ''
        this.forwardQueueSelect = ''
        this.loadData()
        return
      }
      if (this.mode === 'department') {
        const flowId = item.flowId || item.id
        this.flowSelect = String(this.flowSelect) === String(flowId) ? '' : flowId
      } else {
        this.forwardQueueSelect = String(this.forwardQueueSelect) === String(item.id) ? '' : item.id
      }
      this.loadData()
    },
    emitResetData () {
      this.notifyForwardQueueRealtimeFirestoreFallback({
        shopId: this.shopId,
        masBranchID: this.masBranchID,
        eventType: 'booking_added',
        mode: this.mode,
        targetType: this.mode === 'department' ? 'flow' : 'forward_queue',
        statusSound: false
      })
    },
    decorateBookingRow (item) {
      const row = Object.assign({}, item)
      row.bookingDataViewList = this.bookingDataView[row.bookNo] || []
      this.customerFieldNames.forEach(function (field) {
        row['field_' + field.fieldId] = this.getFieldValue(row, field.fieldId)
      }, this)
      return row
    },
    getFieldValue (item, fieldId) {
      const bookingDataViewList = item.bookingDataViewList || []
      const fieldData = bookingDataViewList.filter(function (row) {
        return String(row.fieldId) === String(fieldId)
      })
      if (fieldData.length === 0) return '-'
      const activeFlowId = String(item.activeFlowId || item.currentFlowId || item.flowId)
      const activeMatch = fieldData.filter(function (row) {
        return String(row.flowId) === activeFlowId
      })
      const chosen = activeMatch.length > 0 ? activeMatch[0] : fieldData[0]
      return chosen.fieldValue || '-'
    },
    getBookingDataField (item, fieldId) {
      const bookingDataViewList = item.bookingDataViewList || []
      const fieldData = bookingDataViewList.filter(function (row) {
        return String(row.fieldId) === String(fieldId)
      })
      if (fieldData.length === 0) return null
      const activeFlowId = String(item.activeFlowId || item.currentFlowId || item.flowId)
      const activeMatch = fieldData.filter(function (row) {
        return String(row.flowId) === activeFlowId
      })
      return activeMatch.length > 0 ? activeMatch[0] : fieldData[0]
    },
    isCustomerFieldTextInput (field) {
      return ['text', 'number'].indexOf(field.fieldType) > -1
    },
    getCustomerFieldInputType (field) {
      if (field.fieldType === 'number' && field.fieldName !== 'เบอร์โทร') return 'number'
      return 'text'
    },
    getCustomerFieldRules (field) {
      if (field.requiredField !== 'True') return []
      return [function (value) {
        if (Array.isArray(value)) return value.length > 0 || 'กรุณาระบุข้อมูล'
        return (value !== null && typeof value !== 'undefined' && String(value).trim() !== '') || 'กรุณาระบุข้อมูล'
      }]
    },
    getCustomerFieldOptions (field) {
      if (Array.isArray(field.optionField)) return field.optionField
      try {
        const options = JSON.parse(field.optionField || '[]')
        return Array.isArray(options) ? options : []
      } catch (error) {
        console.log('getCustomerFieldOptions error', error)
        return []
      }
    },
    getCustomerFieldOptionText (option) {
      if (option && typeof option === 'object') return option.text || option.label || option.value || '-'
      return String(option)
    },
    getCustomerFieldOptionValue (option) {
      if (option && typeof option === 'object') {
        if (typeof option.value !== 'undefined') return option.value
        if (typeof option.text !== 'undefined') return option.text
      }
      return option
    },
    parseCustomerFieldArrayValue (value) {
      if (Array.isArray(value)) return value.slice()
      if (!value || value === '-') return []
      try {
        const parsedValue = JSON.parse(value)
        return Array.isArray(parsedValue) ? parsedValue : [parsedValue]
      } catch (error) {
        return [value]
      }
    },
    openCustomerFieldEditDialog (item, field) {
      const bookingDataField = this.getBookingDataField(item, field.fieldId)
      const value = bookingDataField ? bookingDataField.fieldValue : ''
      this.editingCustomerFieldBooking = item
      this.editingCustomerField = Object.assign({}, field, {
        bookingDataId: bookingDataField ? bookingDataField.bookingDataId : 'newDataBooking',
        bookingFieldId: bookingDataField ? bookingDataField.bookingFieldId : this.bookingFieldData.bookingFieldId
      })
      if (field.fieldType === 'Checkbox') {
        this.customerFieldEditCheckboxValues = this.parseCustomerFieldArrayValue(value)
        this.customerFieldEditValue = ''
      } else if (field.fieldType === 'Selects' && field.multiSelect === 'True') {
        this.customerFieldEditValue = this.parseCustomerFieldArrayValue(value)
        this.customerFieldEditCheckboxValues = []
      } else {
        this.customerFieldEditValue = value || ''
        this.customerFieldEditCheckboxValues = []
      }
      this.customerFieldEditValid = true
      this.customerFieldDateMenu = false
      this.dialogCustomerFieldEdit = true
      this.$nextTick(function () {
        if (this.$refs.customerFieldEditForm) this.$refs.customerFieldEditForm.resetValidation()
      })
    },
    closeCustomerFieldEditDialog () {
      this.dialogCustomerFieldEdit = false
      this.editingCustomerField = {}
      this.editingCustomerFieldBooking = null
      this.customerFieldEditValue = ''
      this.customerFieldEditCheckboxValues = []
    },
    async saveCustomerFieldEdit () {
      if (!this.editingCustomerFieldBooking || !this.editingCustomerField.fieldId) return
      const isCheckbox = this.editingCustomerField.fieldType === 'Checkbox'
      if (isCheckbox && this.editingCustomerField.requiredField === 'True' && this.customerFieldEditCheckboxValues.length === 0) return
      if (!isCheckbox && this.$refs.customerFieldEditForm && !this.$refs.customerFieldEditForm.validate()) return

      let fieldValue = isCheckbox
        ? JSON.stringify(this.customerFieldEditCheckboxValues)
        : this.customerFieldEditValue
      if (Array.isArray(fieldValue)) fieldValue = JSON.stringify(fieldValue)
      if (fieldValue === null || typeof fieldValue === 'undefined') fieldValue = ''
      fieldValue = String(fieldValue).replace(/\\/g, '\\\\').replace(/%/g, '%%').replace(/'/g, "\\'")

      const payload = [{
        fieldId: this.editingCustomerField.fieldId,
        bookingDataId: this.editingCustomerField.bookingDataId || 'newDataBooking',
        bookingFieldId: this.editingCustomerField.bookingFieldId || this.bookingFieldData.bookingFieldId,
        bookNo: this.editingCustomerFieldBooking.bookNo,
        fieldValue: fieldValue,
        flowId: this.editingCustomerFieldBooking.activeFlowId || this.editingCustomerFieldBooking.currentFlowId || this.editingCustomerFieldBooking.flowId,
        shopId: this.shopId,
        LAST_USER: this.session.data.userName
      }]

      this.customerFieldEditLoading = true
      try {
        const response = await axios.post(this.$DNS_IP + '/BookingData/editAdminMobile', payload)
        if (!response.data || !response.data.status) {
          throw new Error((response.data && response.data.message) || 'ไม่สามารถบันทึกข้อมูลได้')
        }
        this.closeCustomerFieldEditDialog()
        await this.loadData()
        this.$swal('สำเร็จ', 'แก้ไขข้อมูลเรียบร้อย', 'success')
      } catch (error) {
        console.log('saveCustomerFieldEdit error', error)
        this.$swal('ผิดพลาด', (error && error.message) || 'ไม่สามารถบันทึกข้อมูลได้', 'error')
      } finally {
        this.customerFieldEditLoading = false
      }
    },
    getDisplayFlowName (item) {
      if (item.activeFlowName) return item.activeFlowName
      if (item.flowName) return item.flowName
      const bookingDataViewList = item.bookingDataViewList || []
      if (bookingDataViewList.length > 0 && bookingDataViewList[0].flowName) return bookingDataViewList[0].flowName
      return '-'
    },
    getPrintFlowName (item, language) {
      if (language === 'en') {
        return item.activeFlowNameEn || item.currentFlowNameEn || item.flowNameEn || this.getDisplayFlowName(item)
      }
      return this.getDisplayFlowName(item)
    },
    getPrintFieldName (field, language) {
      if (language === 'en') return field.fieldNameEn || field.fieldName
      return field.fieldName
    },
    // forwardBeforeQueue เก็บ id ของจุดส่งต่อก่อนหน้า แต่คิวที่ไม่เคยถูกส่งต่อเก็บสตริง 'False'
    // ไม่ใช่ NULL การเช็ก !!item.forwardBeforeQueue จึงเป็นจริงกับคิวใหม่ทุกใบ
    // ผลคือคิวที่ยังไม่มีใครเรียกขึ้นป้าย "ส่งกลับ • ยังไม่ได้เรียก" และถูกนับเป็นคิวส่งต่อ
    // (ฝั่ง backend มีตัวเทียบกันที่ is_valid_forward_queue_id ใน BookingForwardQueue.py)
    hasForwardBeforeQueue (item) {
      const value = String((item && item.forwardBeforeQueue) || '').trim().toLowerCase()
      if (!value) return false
      return ['false', 'true', 'null', 'none', '0'].indexOf(value) === -1
    },
    isReturnedQueue (item) {
      return (
        this.mode === 'department' &&
        !item.forwardQueueId &&
        this.hasForwardBeforeQueue(item) &&
        !item.previousFlowId
      )
    },
    isDepartmentCallQueueOnly (item) {
      // คิวส่งกลับที่มากองรอที่ห้องเดิม ไม่ใช่คิวใหม่ — หมอต้องยังส่งต่อและปิดงานได้
      if (this.isReturnedParkedQueue(item)) return false
      return this.isWaitStatus(item) || (this.isDepartmentTransferredQueue(item) && !this.isDepartmentQueueCalled(item))
    },
    // ส่งกลับมาแล้วห้องเต็ม เลยยังไม่ถูกเรียก แต่ยังจองห้องเดิมไว้อยู่
    isReturnedParkedQueue (item) {
      return !!(
        this.isDepartmentTransferredQueue(item) &&
        !this.isDepartmentQueueCalled(item) &&
        String((item && item.servicePoint) || '').trim()
      )
    },
    // ห้องอื่นดึงคิวนี้ไปได้ไหม — ตั้งที่บริการ "ให้ห้องอื่นดึงคิวส่งกลับได้"
    isPullableReturnQueue (item) {
      return !!(
        this.simultaneousCallEnabled &&
        !this.isTerminalQueueStatus(item) &&
        this.isReturnedParkedQueue(item) &&
        this.hasForwardBeforeQueue(item) &&
        item.is_pull_return_queue === 'True'
      )
    },
    // ห้องของ user ประจำห้อง (ดูแลห้องเดียว) — ส่งให้ API ตรวจว่าเป็นคิวของห้องตัวเอง
    getActorServicePoint (item) {
      if (!this.simultaneousCallEnabled || !this.shouldFilterQueueByUserType || this.mode !== 'department') return ''
      const allowed = this.getAllowedServicePointList(item).map(function (point) { return String(point).trim() })
      return allowed.length === 1 ? allowed[0] : ''
    },
    // คิวส่งกลับที่ยังรอห้องอื่น — ห้องนี้กดได้แค่เรียกคิวเข้าห้องตัวเอง
    isPullingFromOtherRoom (item) {
      if (!this.isPullableReturnQueue(item)) return false
      const allowed = this.getAllowedServicePointList(item).map(function (point) { return String(point).trim() })
      return allowed.length > 0 && allowed.indexOf(String(item.servicePoint || '').trim()) === -1
    },
    isDepartmentTransferredQueue (item) {
      return (
        this.mode === 'department' &&
        !item.forwardQueueId &&
        (
          this.hasForwardBeforeQueue(item) ||
          !!item.previousFlowId ||
          (!!item.currentFlowId && String(item.currentFlowId) !== String(item.flowId))
        )
      )
    },
    isDepartmentQueueCalled (item) {
      return !!(item && item.call_queue_date_time)
    },
    getForwardQueuePointName (item) {
      if (!item || !item.forwardQueueId) return ''
      return item.forwardQueueNameTh || item.forwardQueueNameEn || ''
    },
    getServicePointText (item) {
      return this.getForwardQueuePointName(item) || (item && item.servicePoint) || '-'
    },
    getReturnedQueueName (item) {
      return item.forwardBeforeQueueNameTh || item.forwardBeforeQueueNameEn || ''
    },
    getBookingRowClass (item) {
      return this.isReturnedQueue(item) ? 'returned-queue-row' : ''
    },
    getQueueTimeText (item) {
      const rawTime = this.mode === 'department' ? item.LAST_DATE : item.forwardQueueDateTime
      if (!rawTime) return '-'
      const rawTimeMatch = String(rawTime).match(/(\d{2}):(\d{2})/)
      if (rawTimeMatch) return rawTimeMatch[1] + ':' + rawTimeMatch[2]
      const dateTime = moment(rawTime)
      if (!dateTime.isValid()) return '-'
      return dateTime.format('HH:mm')
    },
    hasLineMember (item) {
      if (!item) return false
      const userId = item.userId || ''
      return !!item.lineUserId || (!!userId && userId !== 'user-skip' && userId !== 'data import')
    },
    openLineDialog (item) {
      this.lineBooking = item
      this.dialogLine = true
    },
    async openHistoryDialog (item) {
      this.historyBooking = item
      this.historyItems = []
      this.dialogHistory = true
      this.historyLoading = true
      await axios
        .get(this.$DNS_IP + '/booking_forward_queue/log?bookNo=' + item.bookNo)
        .then(response => {
          const logs = response.data && response.data.status ? response.data.data : []
          this.historyItems = this.buildHistoryItems(item, logs)
        })
        .catch(error => {
          console.log('openHistoryDialog error', error)
          this.historyItems = this.buildHistoryItems(item, [])
        })
      this.historyLoading = false
    },
    buildHistoryItems (item, logs) {
      const historyItems = []
      ;(Array.isArray(logs) ? logs : []).forEach(function (log) {
        const isClosedVisit = !!log.forwardQueueId && !!log.leaveDate &&
          log.status !== 'entered' &&
          ['call_queue', 'recall_queue'].indexOf(log.actionType) === -1 &&
          String(log.enterDate) !== String(log.leaveDate)
        if (!isClosedVisit) {
          historyItems.push(log)
          return
        }
        historyItems.push(Object.assign({}, log, {
          id: log.id + '-enter',
          actionType: 'forward_to_point',
          status: 'entered',
          nextForwardQueueNameTh: null,
          nextForwardQueueNameEn: null,
          toFlowName: null,
          toFlowNameEn: null
        }))
        historyItems.push(Object.assign({}, log, {
          id: log.id + '-leave',
          enterDate: log.leaveDate,
          remark: ''
        }))
      })
      if (item.CREATE_DATE) {
        historyItems.push({
          id: 'booking-start-' + item.bookNo,
          actionType: 'issue_queue',
          status: 'issued',
          enterDate: item.CREATE_DATE,
          fromFlowName: item.flowName || this.getDisplayFlowName(item)
        })
      }
      historyItems.sort(function (a, b) {
        const timeA = new Date(a.enterDate || a.LAST_DATE || a.CREATE_DATE).getTime() || 0
        const timeB = new Date(b.enterDate || b.LAST_DATE || b.CREATE_DATE).getTime() || 0
        if (timeA !== timeB) return timeA - timeB
        return String(a.id).localeCompare(String(b.id))
      })
      const status = this.normalizeBookingStatus(item)
      const hasFinalLog = historyItems.some(function (log) {
        return ['finish', 'cancel_queue'].indexOf(log.actionType) > -1 || ['finish', 'cancel'].indexOf(log.status) > -1
      })
      if (this.isTerminalQueueStatus(item) && !hasFinalLog) {
        const isCancel = ['cancel', 'cancelled'].indexOf(status) > -1
        historyItems.push({
          id: 'booking-final-' + item.bookNo,
          actionType: isCancel ? 'cancel_queue' : 'finish',
          status: isCancel ? 'cancel' : 'finish',
          enterDate: isCancel ? (item.LAST_DATE || item.remarkCancelDate) : (item.close_job_date_time || item.LAST_DATE),
          forwardQueueNameTh: item.forwardBeforeQueueNameTh,
          forwardQueueNameEn: item.forwardBeforeQueueNameEn,
          fromFlowName: this.getDisplayFlowName(item),
          remark: isCancel ? item.remarkCancel : ''
        })
      }
      return historyItems
    },
    formatLogDate (rawTime) {
      if (!rawTime) return '-'
      const rawText = String(rawTime)
      const dateMatch = rawText.match(/(\d{2}):(\d{2})/)
      if (dateMatch) return dateMatch[1] + ':' + dateMatch[2]
      const dateTime = moment(rawTime)
      if (!dateTime.isValid()) return '-'
      return dateTime.format('DD/MM/YYYY HH:mm')
    },
    formatMemberRegisterDate (rawTime) {
      if (!rawTime) return '-'
      const dateTime = moment(rawTime)
      if (!dateTime.isValid()) return '-'
      return dateTime.format('DD/MM/YYYY HH:mm')
    },
    getHistoryTitle (log) {
      const actionType = log.actionType || ''
      const status = log.status || ''
      if (actionType === 'issue_queue') return 'ออกบัตรคิว'
      if (actionType === 'pull_return_queue') return 'ย้ายคิวเข้าห้อง'
      if (actionType === 'call_queue') return 'เรียกคิว'
      if (actionType === 'recall_queue') return 'เรียกคิวซ้ำ'
      if (actionType === 'forward_to_point' && status === 'entered') return 'เข้าจุดส่งต่อ'
      if (actionType === 'forward_to_point') return 'ส่งต่อจุดบริการ'
      if (actionType === 'return_to_flow') return 'ส่งกลับบริการ'
      if (actionType === 'forward_to_flow') return 'ส่งต่อบริการ'
      if (actionType === 'finish') return 'เสร็จสิ้น'
      if (actionType === 'cancel_queue') return 'ยกเลิกคิว'
      if (status === 'returned_to_flow') return 'ส่งกลับบริการ'
      if (status === 'forwarded_to_flow') return 'ส่งต่อบริการ'
      if (status === 'forwarded_out') return 'ส่งต่อจุดบริการ'
      if (status === 'finish') return 'เสร็จสิ้น'
      if (status === 'cancel') return 'ยกเลิกคิว'
      return status || actionType || 'ประวัติ'
    },
    getHistoryDetail (log) {
      const pointName = log.forwardQueueNameTh || log.forwardQueueNameEn || ''
      const nextPointName = log.nextForwardQueueNameTh || log.nextForwardQueueNameEn || ''
      const fromFlowName = log.fromFlowName || log.fromFlowNameEn || ''
      const toFlowName = log.toFlowName || log.toFlowNameEn || ''
      const servicePointText = log.fromServicePoint ? ' (' + log.fromServicePoint + ')' : ''
      if (log.actionType === 'issue_queue') {
        return 'บริการ: ' + (log.fromFlowName || '-')
      }
      if (log.actionType === 'pull_return_queue') {
        return 'จาก ' + (log.fromServicePoint || '-') + ' ไป ' + (log.remark || '-')
      }
      if ((log.actionType === 'finish' || log.actionType === 'cancel_queue') && log.fromServicePoint && !pointName) {
        return 'ปิดงานโดย ' + log.fromServicePoint + (fromFlowName ? ' · บริการ: ' + fromFlowName : '')
      }
      if (log.actionType === 'call_queue' || log.actionType === 'recall_queue') {
        if (log.fromServicePoint) return 'ช่องบริการ ' + log.fromServicePoint
        if (pointName) return 'จุดส่งต่อ: ' + pointName
        return 'บริการ: ' + (fromFlowName || '-')
      }
      if (log.actionType === 'forward_to_flow' || log.status === 'forwarded_to_flow') {
        return 'จาก ' + (pointName || fromFlowName || '-') + ' ไปบริการ ' + (toFlowName || '-')
      }
      if (log.actionType === 'return_to_flow' || log.status === 'returned_to_flow') {
        return 'จาก ' + (pointName || '-') + ' กลับบริการ ' + (toFlowName || fromFlowName || '-') + servicePointText
      }
      if (log.actionType === 'forward_to_point' && nextPointName) {
        return 'จาก ' + (pointName || fromFlowName || '-') + ' ไปจุด ' + nextPointName
      }
      if (pointName) return 'จุดส่งต่อ: ' + pointName + servicePointText
      if (fromFlowName || toFlowName) return 'บริการ: ' + (fromFlowName || '-') + (toFlowName ? ' -> ' + toFlowName : '') + servicePointText
      return '-'
    },
    getHistoryColor (log) {
      const actionType = log.actionType || ''
      const status = log.status || ''
      if (actionType === 'issue_queue') return 'grey'
      if (actionType === 'finish' || status === 'finish') return 'success'
      if (actionType === 'cancel_queue' || status === 'cancel') return 'error'
      if (actionType === 'return_to_flow' || status === 'returned_to_flow') return 'orange'
      if (actionType === 'forward_to_flow' || status === 'forwarded_to_flow') return '#1B437C'
      return 'primary'
    },
    getPrintCustomerLines (item, language) {
      const lines = []
      if (item.bookingDataCustomerName) lines.push((language === 'en' ? 'Name: ' : 'ชื่อ: ') + item.bookingDataCustomerName)
      if (item.bookingDataCustomerTel) lines.push((language === 'en' ? 'Phone: ' : 'เบอร์โทร: ') + item.bookingDataCustomerTel)
      this.customerFieldNames.forEach(function (field) {
        if (['ชื่อ', 'เบอร์โทร', 'Name', 'Phone'].indexOf(field.fieldName) > -1) return
        const value = this.getFieldValue(item, field.fieldId)
        if (value && value !== '-') lines.push(this.getPrintFieldName(field, language) + ': ' + value)
      }, this)
      return lines
    },
    async getPrintShopImage () {
      const shopImage = (this.session.data && this.session.data.shopImge) || ''
      if (!shopImage) return ''
      if (shopImage.indexOf('data:image') === 0) return shopImage
      try {
        const canvasImage = await new Promise(function (resolve) {
          const image = new Image()
          image.crossOrigin = 'anonymous'
          image.onload = function () {
            try {
              const canvas = document.createElement('canvas')
              canvas.width = image.naturalWidth || image.width
              canvas.height = image.naturalHeight || image.height
              const context = canvas.getContext('2d')
              context.drawImage(image, 0, 0)
              resolve(canvas.toDataURL('image/png'))
            } catch (error) {
              resolve('')
            }
          }
          image.onerror = function () {
            resolve('')
          }
          image.src = shopImage
        })
        if (canvasImage) return canvasImage
      } catch (error) {
        console.log('getPrintShopImage canvas error', error)
      }
      try {
        const response = await axios.post(this.$DNS_IP + '/job/image-to-base64', {
          imageUrl: shopImage
        })
        const base64Image = response.data && response.data.base64Image ? response.data.base64Image : ''
        if (base64Image) return 'data:image/jpeg;base64,' + base64Image
      } catch (error) {
        console.log('getPrintShopImage error', error)
      }
      return ''
    },
    // ตัดขอบขาว/โปร่งใสรอบโลโก้ (โลโก้ร้านมักมีขอบว่างติดมา ทำให้ตั๋วสลิปมีช่องว่างบน-ล่างเกินจริง)
    // ใช้เฉพาะตอนปริ้นสลิป 80mm เท่านั้น A4 เดิมไม่แตะ
    async trimPrintImageWhitespace (imageDataUrl) {
      try {
        return await new Promise(function (resolve) {
          const image = new Image()
          image.onload = function () {
            try {
              const canvas = document.createElement('canvas')
              canvas.width = image.naturalWidth || image.width
              canvas.height = image.naturalHeight || image.height
              const context = canvas.getContext('2d')
              context.drawImage(image, 0, 0)
              const data = context.getImageData(0, 0, canvas.width, canvas.height).data
              let top = canvas.height
              let left = canvas.width
              let right = -1
              let bottom = -1
              for (let y = 0; y < canvas.height; y++) {
                for (let x = 0; x < canvas.width; x++) {
                  const index = (y * canvas.width + x) * 4
                  const isBlank = data[index + 3] < 16 ||
                    (data[index] > 245 && data[index + 1] > 245 && data[index + 2] > 245)
                  if (!isBlank) {
                    if (x < left) left = x
                    if (x > right) right = x
                    if (y < top) top = y
                    if (y > bottom) bottom = y
                  }
                }
              }
              if (right <= left || bottom <= top) return resolve(imageDataUrl)
              // โลโก้ที่ขนาดพอดีอยู่แล้ว (แทบไม่มีขอบว่าง) -> คืนรูปเดิม ไม่แตะอะไรเลย
              if (left <= 2 && top <= 2 && right >= canvas.width - 3 && bottom >= canvas.height - 3) {
                return resolve(imageDataUrl)
              }
              const cropCanvas = document.createElement('canvas')
              cropCanvas.width = right - left + 1
              cropCanvas.height = bottom - top + 1
              cropCanvas.getContext('2d').drawImage(canvas, left, top, cropCanvas.width, cropCanvas.height, 0, 0, cropCanvas.width, cropCanvas.height)
              resolve(cropCanvas.toDataURL('image/png'))
            } catch (error) {
              resolve(imageDataUrl)
            }
          }
          image.onerror = function () {
            resolve(imageDataUrl)
          }
          image.src = imageDataUrl
        })
      } catch (error) {
        return imageDataUrl
      }
    },
    async getPrintConfig () {
      try {
        const response = await axios.get(this.$DNS_IP + '/booking_forward_queue/print_config?shopId=' + this.shopId)
        const data = response.data && response.data.status ? response.data.data : null
        this.printConfig = data || {}
      } catch (error) {
        // ดึงค่าไม่ได้ = ใช้ค่าเดิม (A4 + ข้อความท้ายบัตรเริ่มต้น)
        console.log('getPrintConfig error', error)
        this.printConfig = {}
      }
    },
    openPrintSettingDialog () {
      this.printSettingForm = {
        paperSize: this.printConfig.paperSize === '80mm' ? '80mm' : 'A4',
        footerTextTh: this.printConfig.footerTextTh || '',
        footerTextEn: this.printConfig.footerTextEn || ''
      }
      this.dialogPrintSetting = true
    },
    async savePrintSetting () {
      this.printSettingLoading = true
      try {
        const response = await axios.post(this.$DNS_IP + '/booking_forward_queue/print_config', {
          shopId: this.shopId,
          paperSize: this.printSettingForm.paperSize,
          footerTextTh: this.printSettingForm.footerTextTh || '',
          footerTextEn: this.printSettingForm.footerTextEn || '',
          LAST_USER: this.session.data.userName
        })
        if (!response.data || !response.data.status) {
          throw new Error((response.data && response.data.message) || 'ไม่สามารถบันทึกการตั้งค่าได้')
        }
        this.printConfig = response.data.data || {}
        this.dialogPrintSetting = false
        this.$swal('สำเร็จ', 'บันทึกการตั้งค่าปริ้นเรียบร้อย', 'success')
      } catch (error) {
        console.log('savePrintSetting error', error)
        const message = (error.response && error.response.data && error.response.data.message) ||
          error.message ||
          'ไม่สามารถบันทึกการตั้งค่าได้'
        this.$swal('ผิดพลาด', message, 'error')
      } finally {
        this.printSettingLoading = false
      }
    },
    getPrintFooterText (language) {
      const configText = language === 'en' ? this.printConfig.footerTextEn : this.printConfig.footerTextTh
      const footerText = configText === null || typeof configText === 'undefined' ? '' : String(configText).trim()
      if (footerText) return footerText
      return language === 'en' ? DEFAULT_PRINT_FOOTER_EN : DEFAULT_PRINT_FOOTER_TH
    },
    // A4 แบบเดิม (ร้านที่ไม่ได้ตั้งค่า) — ห้ามแก้ค่าใด ๆ ในเมธอดนี้
    buildPrintDocDefinitionA4 (printData) {
      const item = printData.item
      const language = printData.language
      const qrContent = printData.qrUrl
        ? [
          { text: language === 'th' ? 'สแกน QR Code เพื่อรับการแจ้งเตือนคิวของคุณ' : 'Scan QR Code for queue notification', style: 'qrLabel', alignment: 'center', margin: [0, 2, 0, 4] },
          { qr: printData.qrUrl, fit: 145, alignment: 'center', margin: [0, 0, 0, 12] }
        ]
        : []
      const headerContent = printData.shopImage
        ? [{ image: printData.shopImage, fit: [360, 135], alignment: 'center', margin: [0, 0, 0, 12] }]
        : [{ text: printData.shopName, style: 'shopName', alignment: 'center', margin: [0, 0, 0, 8] }]
      const servicePointContent = item.servicePoint
        ? [{ text: language === 'th' ? 'คิวที่รออยู่ ' + item.servicePoint : 'Service point ' + item.servicePoint, style: 'servicePoint', alignment: 'center', margin: [0, 0, 0, 4] }]
        : []
      return {
        pageSize: 'A4',
        pageMargins: [36, 28, 36, 28],
        content: headerContent.concat([
          { text: printData.flowName, style: 'flowName', alignment: 'center', margin: [0, 0, 0, 4] },
          { text: language === 'th' ? 'หมายเลขคิวของคุณ' : 'Your queue number', style: 'label', alignment: 'center', margin: [0, 0, 0, 4] },
          { text: item.storeFrontQueue || '-', style: 'queueNo', alignment: 'center', margin: [0, 0, 0, 0] }
        ], servicePointContent, qrContent, [
          {
            text: printData.customerLines.length > 0 ? printData.customerLines.join('\n') : '',
            style: 'customer',
            alignment: 'center',
            margin: [0, 0, 0, 10]
          },
          {
            text: printData.footerText,
            style: 'footerNote',
            alignment: 'center',
            margin: [22, 0, 22, 10]
          },
          {
            text: (language === 'th' ? 'วันที่ ' : 'Date ') + printData.printDate,
            style: 'dateText',
            alignment: 'center'
          }
        ]),
        styles: {
          shopName: { fontSize: 22, bold: true },
          flowName: { fontSize: 20, bold: true },
          label: { fontSize: 14, bold: true },
          queueNo: { fontSize: 72, bold: true },
          servicePoint: { fontSize: 13, bold: true },
          qrLabel: { fontSize: 11 },
          customer: { fontSize: 11 },
          footerNote: { fontSize: 10, lineHeight: 1.15 },
          dateText: { fontSize: 11 }
        },
        defaultStyle: {
          font: 'Kanit'
        }
      }
    },
    // สลิป 80mm ให้ตรงกับบัตรคิวของเครื่อง POS (window_select_queue)
    // กระดาษกว้าง 80mm = 226.77pt แต่หัวพิมพ์พิมพ์ได้จริง 72mm จึงเว้นขอบข้างละ 4mm (11.34pt)
    // ตั๋วเลย์เอาต์เดียวกับเครื่อง POS (window_select_queue)
    // scale 1 = ขนาดเท่าตั๋ว POS เป๊ะ (สลิป 80mm)
    buildPosTicketDocDefinition (printData, options) {
      const item = printData.item
      const language = printData.language
      const size = function (value) { return Math.round(value * options.scale * 100) / 100 }
      const gap = size(POS_TICKET_BASE.gap)
      const gapSmall = size(POS_TICKET_BASE.gapSmall)
      const qrContent = printData.qrUrl
        ? [
          { text: language === 'th' ? 'สแกน QR Code เพื่อรับการแจ้งเตือนคิวของคุณ' : 'Scan QR Code for queue notification', style: 'qrLabel', alignment: 'center', margin: [0, 0, 0, gap] },
          { qr: printData.qrUrl, fit: size(POS_TICKET_BASE.qr), alignment: 'center', margin: [0, gap, 0, gap] }
        ]
        : []
      // POS ตั้ง width: 200px height: auto -> ใช้ width (ไม่ใช่ fit) จะได้กว้างเท่ากันเสมอ
      const headerContent = printData.shopImage
        ? [{ image: printData.shopImage, width: size(POS_TICKET_BASE.logoWidth), alignment: 'center', margin: [0, 0, 0, 0] }]
        : [{ text: printData.shopName, style: 'shopName', alignment: 'center', margin: [0, 0, 0, gap] }]
      const servicePointContent = item.servicePoint
        ? [{ text: (language === 'th' ? 'ช่องบริการ ' : 'Service point ') + item.servicePoint, style: 'servicePoint', alignment: 'center', margin: [0, gapSmall, 0, 0] }]
        : []
      const customerContent = printData.customerLines.length > 0
        ? [{ text: printData.customerLines.join('\n'), style: 'customer', alignment: 'center', margin: [0, gap, 0, 0] }]
        : []
      return {
        pageSize: options.pageSize,
        pageMargins: options.pageMargins,
        content: headerContent.concat([
          { text: printData.flowName, style: 'flowName', alignment: 'center', margin: [0, gap, 0, 0] },
          { text: item.storeFrontQueue || '-', style: 'queueNo', alignment: 'center', margin: [0, 0, 0, 0] }
        ], servicePointContent, qrContent, customerContent, [
          {
            text: printData.footerText,
            style: 'footerNote',
            alignment: 'center',
            margin: [0, gap, 0, gap]
          },
          {
            text: (language === 'th' ? 'วันที่ ' : 'Date ') + printData.printDate,
            style: 'dateText',
            alignment: 'center',
            margin: [0, gap, 0, gap]
          }
        ]),
        styles: {
          shopName: { fontSize: size(POS_TICKET_BASE.flowName), bold: true },
          flowName: { fontSize: size(POS_TICKET_BASE.flowName) },
          queueNo: { fontSize: size(POS_TICKET_BASE.queueNo), bold: true },
          servicePoint: { fontSize: size(POS_TICKET_BASE.secondary) },
          qrLabel: { fontSize: size(POS_TICKET_BASE.secondary) },
          customer: { fontSize: size(POS_TICKET_BASE.customer) },
          footerNote: { fontSize: size(POS_TICKET_BASE.footerNote), lineHeight: 1.15 },
          dateText: { fontSize: size(POS_TICKET_BASE.secondary) }
        },
        defaultStyle: {
          font: 'Kanit'
        }
      }
    },
    async setPrint (item, language) {
      const isPosSlip = this.printConfig.paperSize === '80mm'
      const shopName = (this.session.data && (this.session.data.shopName || this.session.data.shopNameTh)) || ''
      const flowName = this.getPrintFlowName(item, language)
      let shopImage = await this.getPrintShopImage()
      if (isPosSlip && shopImage) {
        // สลิปพื้นที่แคบ ตัดขอบว่างของโลโก้ออกก่อน ไม่งั้นช่องว่างบน-ล่างโลโก้กินที่จนเนื้อหาไปกองข้างล่าง
        shopImage = await this.trimPrintImageWhitespace(shopImage)
      }
      const dateValue = moment(this.dateStart)
      const printDate = language === 'th'
        ? dateValue.clone().add(543, 'years').format('DD/MM/YYYY') + ' เวลา ' + moment().format('HH:mm')
        : dateValue.format('YYYY-MM-DD') + ' ' + moment().format('HH:mm')
      const customerLines = this.getPrintCustomerLines(item, language)
      const liffMainID = this.dataLineConfig && this.dataLineConfig.liffMainID ? this.dataLineConfig.liffMainID : ''
      const qrUrl = liffMainID
        ? 'https://liff.line.me/' + liffMainID + '/ConfirmUser?bookNo=' + item.bookNo + '&shopId=' + item.shopId
        : ''
      const printData = {
        item: item,
        language: language,
        shopName: shopName,
        shopImage: shopImage,
        flowName: flowName,
        printDate: printDate,
        customerLines: customerLines,
        qrUrl: qrUrl,
        footerText: this.getPrintFooterText(language)
      }
      // ร้านที่ไม่ได้ตั้งค่า = A4 แบบเดิมทุกประการ
      const docDefinition = isPosSlip
        ? this.buildPosTicketDocDefinition(printData, POS_TICKET_80MM_PAGE)
        : this.buildPrintDocDefinitionA4(printData)

      pdfMake.vfs = pdfFonts.pdfMake.vfs
      pdfMake.fonts = {
        Roboto: {
          normal: 'Roboto-Regular.ttf',
          bold: 'Roboto-Medium.ttf',
          italics: 'Roboto-Italic.ttf',
          bolditalics: 'Roboto-MediumItalic.ttf'
        },
        Kanit: {
          normal: 'Kanit-Regular.ttf',
          bold: 'Kanit-Medium.ttf',
          italics: 'Kanit-Italic.ttf',
          bolditalics: 'Kanit-MediumItalic.ttf'
        }
      }

      const userAgent = navigator.userAgent
      if (userAgent.indexOf('Firefox') > -1) {
        pdfMake.createPdf(docDefinition).download((item.storeFrontQueue || 'Queue') + '.pdf')
      } else {
        pdfMake.createPdf(docDefinition).getDataUrl(function (outDoc) {
          const dataReplate = outDoc.replace('data:application/pdf;base64,', '')
          printJS({ printable: dataReplate, type: 'pdf', base64: true })
        })
      }
    },
    normalizeBookingStatus (item) {
      return String((item && item.BookingStatus) || 'wait')
    },
    isWaitStatus (item) {
      const status = this.normalizeBookingStatus(item)
      return status === 'wait' || status === '' || status === 'null' || status === 'None'
    },
    isTerminalQueueStatus (item) {
      const status = this.normalizeBookingStatus(item)
      return ['finish', 'closed', 'success', 'cancel', 'cancelled'].indexOf(status) > -1
    },
    getTerminalQueueStatusText (item) {
      const status = this.normalizeBookingStatus(item)
      if (['finish', 'closed', 'success'].indexOf(status) > -1) return 'เสร็จแล้ว'
      if (['cancel', 'cancelled'].indexOf(status) > -1) return 'ยกเลิกแล้ว'
      return '-'
    },
    getTerminalQueueStatusColor (item) {
      const status = this.normalizeBookingStatus(item)
      if (['finish', 'closed', 'success'].indexOf(status) > -1) return '#1B8F3A'
      if (['cancel', 'cancelled'].indexOf(status) > -1) return '#E53935'
      return '#7b8794'
    },
    isForwardPointCalled (item) {
      if (!item || !item.call_queue_date_time) return false
      if (!item.forwardQueueDateTime) return true
      const callTime = new Date(item.call_queue_date_time).getTime()
      const enterPointTime = new Date(item.forwardQueueDateTime).getTime()
      if (isNaN(callTime) || isNaN(enterPointTime)) return true
      return callTime >= enterPointTime
    },
    openActionDialog (item, action) {
      this.selectedBooking = item
      this.actionForm = {
        action: action,
        targetType: 'forward_queue',
        targetForwardQueueId: '',
        targetFlowId: '',
        remark: ''
      }
      this.dialogAction = true
    },
    selectForwardQueueTarget () {
      this.actionForm.targetType = 'forward_queue'
      this.actionForm.targetFlowId = ''
    },
    selectFlowTarget () {
      this.actionForm.targetType = 'flow'
      this.actionForm.targetForwardQueueId = ''
    },
    async submitDirectAction (item, action, extraPayload) {
      if (!extraPayload && this.shouldSelectServicePoint(item, action)) {
        await this.openServicePointDialog(item)
        return
      }
      const returnedQueueStatusSound = await this.confirmReturnedQueueSound(item, action)
      if (returnedQueueStatusSound === undefined) return
      const payload = {
        action: action,
        bookNo: item.bookNo,
        LAST_USER: this.session.data.userName
      }
      if (extraPayload) Object.assign(payload, extraPayload)
      if (action !== 'call_queue' && this.getActorServicePoint(item)) {
        payload.actorServicePoint = this.getActorServicePoint(item)
      }
      if (payload.servicePoint && this.session.data && this.session.data.empId) {
        payload.storeFrontQueueEmpId = this.session.data.empId
      }
      // กันกดปุ่มเดิมของคิวเดิมซ้ำระหว่างที่ยังส่งไม่เสร็จ (double-submit)
      const submitKey = item.bookNo + ':' + action
      if (this.submittingActionKeys.indexOf(submitKey) !== -1) return
      this.submittingActionKeys.push(submitKey)
      axios
        .post(this.$DNS_IP + '/booking_forward_queue/action', payload)
        .then(async response => {
          if (response.data && response.data.status) {
            let swalTitle = 'สำเร็จ'
            let swalMsg = response.data.message || 'บันทึกข้อมูลสำเร็จ'
            let swalType = 'success'
            // คิวส่งกลับ: บอกให้ชัดว่าเข้าห้องเลย (ห้องว่าง) หรือพักรอ (ห้องเต็ม)
            if (action === 'return_to_flow' && this.simultaneousCallEnabled) {
              if (response.data.pullReturnQueue) {
                swalTitle = 'ส่งกลับแล้ว — ' + response.data.servicePoint + ' ยังเต็ม'
                swalMsg = 'คิวรอเรียกอยู่ที่ ' + response.data.servicePoint + ' ห้องตรวจอื่นกด "เรียกคิว" ไปทำต่อได้'
                swalType = 'info'
              } else if (response.data.autoCalled) {
                swalTitle = 'ส่งกลับสำเร็จ'
                swalMsg = 'ห้องว่าง เรียกคิวเข้าห้องเดิมและแสดงบนจอเรียกคิวแล้ว'
                swalType = 'success'
              } else {
                swalTitle = 'ส่งกลับแล้ว — ห้องยังเต็ม'
                swalMsg = 'คิวถูกพักไว้ที่ห้องเดิมรอเรียก กดปุ่ม "เรียกคิว" เมื่อห้องว่าง'
                swalType = 'info'
              }
            }
            this.$swal(swalTitle, swalMsg, swalType)
            let notifyExtraData = returnedQueueStatusSound === null ? null : { statusSound: returnedQueueStatusSound }
            if (typeof response.data.callQueueSound === 'boolean') {
              notifyExtraData = { statusSound: response.data.callQueueSound }
            }
            this.notifyForwardQueueRealtime(item, action, notifyExtraData)
            await this.notifyLineQueue(item, action)
            await this.notifyBeforeLineQueue(item, action)
            this.loadData()
          } else {
            this.$swal('ผิดพลาด', response.data.message || 'ไม่สามารถบันทึกข้อมูลได้', 'error')
          }
        })
        .catch(error => {
          console.log('submitDirectAction error', error)
          // เคสห้องเต็ม/จำกัดจำนวน API ตอบ HTTP error พร้อม message จริง (เช่น "ห้องตรวจ 1 ... เต็มจำนวน (2 คิว) แล้ว")
          // ต้องโชว์ message นั้น ไม่ใช่ generic "ไม่สามารถบันทึกข้อมูลได้"
          const apiMsg = error && error.response && error.response.data && error.response.data.message
          const msg = apiMsg || (error && error.message) || 'ไม่สามารถบันทึกข้อมูลได้'
          // เรียกคิวแล้วห้องเต็ม (เช่น คิวส่งกลับมาแต่ห้องตรวจยังมีคิวค้าง) ไม่ใช่ error ของระบบ
          // ให้ขึ้นเป็น "แจ้งเตือน" info เหมือนตอนเปิดเลือกช่องบริการแล้วรอบบริการครบ
          const isRoomFull = !!apiMsg && (action === 'call_queue' || action === 'recall_queue') &&
            apiMsg.indexOf('เต็มจำนวนที่ตั้งไว้') !== -1
          if (isRoomFull) this.$swal('แจ้งเตือน', msg, 'info')
          else this.$swal('ผิดพลาด', msg, 'error')
        })
        .finally(() => {
          const idx = this.submittingActionKeys.indexOf(submitKey)
          if (idx !== -1) this.submittingActionKeys.splice(idx, 1)
        })
    },
    async submitAction () {
      if (!this.selectedBooking) return
      if (this.actionForm.action === 'forward_to_point' && this.actionForm.targetType === 'forward_queue' && !this.actionForm.targetForwardQueueId) {
        this.$swal('แจ้งเตือน', 'กรุณาเลือกจุดส่งต่อ', 'info')
        return
      }
      if (
        (this.actionForm.action === 'forward_to_flow' ||
          (this.actionForm.action === 'forward_to_point' && this.actionForm.targetType === 'flow')) &&
        !this.actionForm.targetFlowId
      ) {
        this.$swal('แจ้งเตือน', 'กรุณาเลือกบริการ', 'info')
        return
      }
      const payload = {
        action: this.actionForm.action === 'forward_to_point' && this.actionForm.targetType === 'flow' ? 'forward_to_flow' : this.actionForm.action,
        bookNo: this.selectedBooking.bookNo,
        targetForwardQueueId: this.actionForm.targetForwardQueueId,
        targetFlowId: this.actionForm.targetFlowId,
        remark: this.actionForm.remark,
        LAST_USER: this.session.data.userName
      }
      if (this.getActorServicePoint(this.selectedBooking)) {
        payload.actorServicePoint = this.getActorServicePoint(this.selectedBooking)
      }
      axios
        .post(this.$DNS_IP + '/booking_forward_queue/action', payload)
        .then(async response => {
          if (response.data && response.data.status) {
            this.$swal('สำเร็จ', response.data.message || 'บันทึกข้อมูลสำเร็จ', 'success')
            const autoCalled = payload.action === 'forward_to_point' && response.data.autoCalled === true
            const notifyExtraData = payload.action === 'forward_to_flow'
              ? Object.assign({ targetType: 'flow' }, this.getFlowTargetData(payload.targetFlowId))
              : Object.assign({ targetType: 'forward_queue' }, this.getForwardQueueTargetData(payload.targetForwardQueueId))
            if (autoCalled) notifyExtraData.statusSound = response.data.callQueueSound === true
            await this.notifyForwardQueueRealtime(this.selectedBooking, autoCalled ? 'call_queue' : payload.action, notifyExtraData)
            if (autoCalled) await this.notifyLineQueue(this.selectedBooking, 'call_queue', 'forward_queue')
            this.dialogAction = false
            this.loadData()
          } else {
            this.$swal('ผิดพลาด', response.data.message || 'ไม่สามารถบันทึกข้อมูลได้', 'error')
          }
        })
        .catch(error => {
          console.log('submitAction error', error)
          this.$swal('ผิดพลาด', 'ไม่สามารถบันทึกข้อมูลได้', 'error')
        })
    }
  }
}
</script>

<style scoped>
/* ตารางคิว: ทำให้เลื่อนไปด้านข้างได้ และแถบเลื่อนโชว์ค้างไว้ตลอด
   หมายเหตุ: ห้ามใส่ scrollbar-width / scrollbar-color ที่นี่ — Chrome 121+ ถ้าเจอ 2 ตัวนี้
   จะทิ้งกฎ ::-webkit-scrollbar ทั้งหมด แล้วกลับไปใช้แถบลอยของ macOS ที่ซ่อนตัวเอง */
.queue-data-table /deep/ .v-data-table__wrapper {
  overflow-x: scroll !important;
}

.queue-data-table /deep/ .v-data-table__wrapper th,
.queue-data-table /deep/ .v-data-table__wrapper td {
  white-space: nowrap;
}

/* แถบเลื่อน: ทรงเหลี่ยม ตัวใหญ่ จับง่ายสำหรับผู้ใช้สูงอายุ */
.queue-data-table /deep/ .v-data-table__wrapper::-webkit-scrollbar {
  -webkit-appearance: none;
  height: 16px;
}

.queue-data-table /deep/ .v-data-table__wrapper::-webkit-scrollbar-track {
  background: #eef2f7;
  border-radius: 0;
}

.queue-data-table /deep/ .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background: #8fa3bd;
  border-radius: 0;
  min-width: 56px;
}

.queue-data-table /deep/ .v-data-table__wrapper::-webkit-scrollbar-thumb:hover,
.queue-data-table /deep/ .v-data-table__wrapper::-webkit-scrollbar-thumb:active {
  background: #5d7793;
}

.queue-filter-card {
  border-bottom: 1px solid #edf1f7;
}

.queue-filter-card .v-card__text {
  padding: 8px 0 18px;
}

.queue-filter-col {
  padding-top: 6px;
  padding-bottom: 6px;
}

.queue-filter-control {
  max-width: 180px;
}

.queue-action-col {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding-top: 6px;
  padding-bottom: 6px;
  min-width: 0;
  white-space: normal;
}

.queue-toolbar-btn,
.forward-add-booking ::v-deep .bottomAdd {
  height: 40px !important;
  border-radius: 6px;
  letter-spacing: 0;
}

.queue-export-wrapper {
  display: inline-flex;
  flex: 0 0 auto;
}

.queue-export-btn {
  min-width: 112px;
  text-transform: uppercase;
}

.queue-refresh-btn {
  min-width: 118px;
}

.forward-add-booking ::v-deep .bottomAdd {
  min-width: 240px;
  box-shadow: 0 3px 8px rgba(33, 150, 243, 0.24);
  font-size: 14px;
  padding: 0 16px !important;
  background-color: #2196f3 !important;
}

.forward-add-booking {
  flex: 0 0 auto;
}

.queue-overview-row {
  row-gap: 8px;
}

.queue-overview-card {
  min-width: 172px;
  cursor: pointer;
  border: 1px solid #dce5f2 !important;
  border-radius: 8px;
  transition: border-color 0.16s ease, box-shadow 0.16s ease, transform 0.16s ease;
}

.queue-overview-card:hover {
  border-color: #1B437C !important;
  box-shadow: 0 4px 14px rgba(27, 67, 124, 0.14);
  transform: translateY(-1px);
}

.queue-overview-card-active {
  border-color: #49b86d !important;
  box-shadow: 0 4px 14px rgba(73, 184, 109, 0.16);
}

.queue-action-btn {
  min-width: 88px;
  letter-spacing: 0;
}

.queue-customer-field-cell {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}

.queue-customer-field-edit-btn {
  margin-left: 2px;
}

.queue-customer-field-label {
  color: rgba(0, 0, 0, 0.6);
  font-size: 12px;
  margin-bottom: 4px;
}

.queue-customer-field-choice {
  margin-bottom: 16px;
}

.queue-customer-field-required {
  color: #ff5252;
  font-size: 12px;
  margin-top: 8px;
}

.queue-number-cell {
  align-items: center;
  display: flex;
  gap: 4px;
}

.queue-number-btn {
  letter-spacing: 0;
  min-width: 0;
  padding: 0 4px !important;
}

.queue-line-btn {
  background: transparent !important;
  height: 28px !important;
  width: 28px !important;
}

.queue-line-icon {
  display: block;
  height: 24px;
  width: 24px;
}

.queue-status-chip {
  min-width: 86px;
  justify-content: center;
  font-weight: 600;
  letter-spacing: 0;
}

.queue-print-actions {
  display: flex;
  justify-content: center;
  white-space: nowrap;
}

.queue-print-btn {
  min-width: 56px;
  border-radius: 5px;
  letter-spacing: 0;
}

.queue-print-setting-hint {
  font-size: 12px;
  color: #809FB8;
  line-height: 1.4;
}

.returned-queue-chip {
  font-weight: 600;
  letter-spacing: 0;
}

.return-origin-note {
  padding: 8px 12px;
  border-radius: 8px;
  background: #fff7ed;
  color: #9a3412;
  font-size: 14px;
}

::v-deep tr.returned-queue-row {
  background: #fff7ed;
}

.service-point-origin {
  color: #94a3b8;
  white-space: nowrap;
}

.forward-booking-summary {
  background: #f7f9fc;
  border: 1px solid #e7edf5;
  border-radius: 6px;
  color: #4d5968;
  padding: 10px 12px;
}

.queue-dialog-title {
  color: #2b2f33;
  font-size: 20px;
  font-weight: 700;
}

.queue-history-title {
  color: #2b2f33;
  font-weight: 700;
}

.queue-history-time {
  color: #7b8794;
  font-size: 12px;
}

.queue-history-detail,
.queue-history-remark {
  color: #4d5968;
  margin-top: 4px;
}

.queue-empty-state {
  color: #7b8794;
  padding: 24px 0;
  text-align: center;
}

.line-profile-card {
  align-items: center;
  display: flex;
}

.line-profile-name {
  color: #2b2f33;
  font-size: 18px;
  font-weight: 700;
}

.line-profile-sub {
  color: #7b8794;
}

.line-info-table td:first-child {
  color: #7b8794;
  width: 128px;
}

.forward-booking-subtitle {
  color: #7b8794;
  font-size: 13px;
  margin-top: 4px;
}

.forward-dialog-section-label {
  color: #777;
  font-size: 13px;
  margin-top: 12px;
}

.queue-target-grid {
  margin-top: 8px;
}

.queue-target-col {
  min-height: 44px;
}

.queue-target-grid ::v-deep .v-input--radio-group__input {
  width: 100%;
}

.queue-target-grid ::v-deep .v-radio .v-label {
  color: #5f6368;
  font-weight: 600;
  line-height: 1.25;
}

@media (max-width: 959px) {
  .queue-filter-control {
    max-width: none;
  }

  .queue-action-col {
    justify-content: flex-start;
    flex-wrap: wrap;
    white-space: normal;
  }

  .queue-toolbar-btn,
  .queue-export-wrapper,
  .forward-add-booking {
    margin-bottom: 8px;
  }

  .forward-add-booking ::v-deep .bottomAdd {
    min-width: 192px;
  }

  .queue-target-col {
    min-height: 38px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Master/BookingForwardQueue.vue